import React, { PureComponent } from "react";
import {
    Button,
    Card,
    Col,
    DatePicker,
    Drawer,
    Form,
    Icon,
    Input,
    InputNumber,
    notification,
    Row,
    Select,
    Steps,
    Table,
    Tabs,
    Tag,
    Tooltip,
    Switch,
    Spin,
    Checkbox,
    Modal,
    Avatar
} from "antd";
import _ from "lodash";
import Moment from "moment";
import Each from "async/each";
import { connect } from "react-redux";
import Request, { API_URL, LAPI_URL, MEDIA_URL } from "../../../request";
import StudentHeader from "../../../components/studentHeader";
import AddBranch from "../../../containers/Masters/branch/add/index";
import style from "./add/style.less";
import { hideLoader, showLoader } from "../../../modules/actions";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
import Exception from "../../../components/Exception";
import { Link } from "react-router-dom";
import Webcam from "react-webcam";
import rightAuth from '../../../components/_utils/userRights';
import moment from "moment";

const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
const videoConstraints = {
    width: 1280,
    height: 720,
    facingMode: "user",
    imageSmoothing: false,
};
const TabPane = Tabs.TabPane;
let sourceOptions = ["Direct", "Sub Agent", "Employee Referral", "Lead Referral", "External Referral", "Loyality Program"];
const Option = Select.Option;

// Section Header with Icon Badge
const SectionTitle = ({ icon, title, color = "#1890ff", bgColor = "#e6f7ff" }) => (
    <div style={{ display: 'flex', alignItems: 'center', margin: '8px 0 16px 0' }}>
        <div style={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            backgroundColor: bgColor,
            color: color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: 10,
            fontSize: 16
        }}>
            <Icon type={icon} />
        </div>
        <span style={{ fontSize: 16, fontWeight: 700, color: '#1f1f1f' }}>{title}</span>
    </div>
);

// Additional Qualification Level Options
const additionalLevelOptions = [
    "Other",
    "Pathway Program (PG)",
    "Pathway Program (UG)",
    "PhD",
    "PG Diploma/Certificate",
    "UG Diploma/Certificate/Associate Degree",
    "Grade 11th",
    "Grade 9th",
    "Foundation"
];

// Academic Qualification Card Component
// class QualificationCard extends React.Component {
//     state = {
//         trigger: 0
//     };

//     changeScoreOptions = () => {
//         this.setState({ trigger: Math.random() });
//     };

//     render() {
//         const { title, icon, color = "#1890ff", bgColor = "#e6f7ff", form, idPrefix, countries = [], states = [], defaultCountry = undefined, onRemove = null, isAdditional = false } = this.props;
//         const { getFieldDecorator } = form;

//         let gradingSystem = form.getFieldValue(`${idPrefix}_gradingSystem`);
//         let qualStatus = form.getFieldValue(`${idPrefix}_qualificationStatus`);
//         let isPursuing = qualStatus === "Pursuing";
//         let gradingSystemScores = [];
//         if (gradingSystem === "Percentage") {
//             for (let i = 30; i <= 100; i++) {
//                 gradingSystemScores.push({ key: `${i}`, display: `${i}` });
//             }
//         } else if (gradingSystem === "CGPA 10.0 Scale") {
//             for (let i = 0; i < 10; i++) {
//                 for (let d = 0; d < 10; d++) {
//                     gradingSystemScores.push({ key: `${i}.${d}`, display: `${i}.${d}` });
//                 }
//             }
//             gradingSystemScores.push({ key: `10`, display: `10` });
//         } else if (gradingSystem === "GPA 4.0 Scale") {
//             gradingSystemScores = [
//                 { key: "1", display: "1" }, { key: "1.3", display: "1.3" }, { key: "1.7", display: "1.7" },
//                 { key: "2", display: "2" }, { key: "2.3", display: "2.3" }, { key: "2.5", display: "2.5" },
//                 { key: "2.7", display: "2.7" }, { key: "2.75", display: "2.75" }, { key: "2.8", display: "2.8" },
//                 { key: "3", display: "3" }, { key: "3.1", display: "3.1" }, { key: "3.2", display: "3.2" },
//                 { key: "3.3", display: "3.3" }, { key: "3.4", display: "3.4" }, { key: "3.5", display: "3.5" },
//                 { key: "3.6", display: "3.6" }, { key: "3.7", display: "3.7" }, { key: "3.8", display: "3.8" },
//                 { key: "3.9", display: "3.9" }, { key: "4", display: "4" }
//             ];
//         } else if (gradingSystem === "Letter Grade") {
//             gradingSystemScores = [
//                 { key: "A+", display: "A+" }, { key: "A", display: "A" }, { key: "A-", display: "A-" },
//                 { key: "B+", display: "B+" }, { key: "B", display: "B" }, { key: "B-", display: "B-" },
//                 { key: "C+", display: "C+" }, { key: "C", display: "C" }, { key: "C-", display: "C-" },
//                 { key: "D+", display: "D+" }, { key: "D", display: "D" }
//             ];
//         } else if (gradingSystem === "IB Grade") {
//             gradingSystemScores = [
//                 { key: "3", display: "3" }, { key: "4", display: "4" },
//                 { key: "5", display: "5" }, { key: "6", display: "6" }, { key: "7", display: "7" }
//             ];
//         }

//         return (
//             <div style={{ background: "#fff", padding: "20px", borderRadius: "10px", border: "1px solid #f0f0f0", marginBottom: 20, boxShadow: "0 1px 3px rgba(0,0,0,0.02)", borderLeft: `4px solid ${color}` }}>
//                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                     <SectionTitle icon={icon} title={title} color={color} bgColor={bgColor} />
//                     {onRemove && (
//                         <Button type="link" onClick={onRemove} style={{ color: "#ff4d4f", fontWeight: 600 }}>
//                             <Icon type="delete" /> Remove
//                         </Button>
//                     )}
//                 </div>
//                 <Row gutter={16}>
//                     <Col span={6}>
//                         <Form.Item label={<span style={{ fontWeight: 600 }}>Qualification Status</span>}>
//                             {getFieldDecorator(`${idPrefix}_qualificationStatus`, { rules: [{ required: true, message: "Select status" }] })(
//                                 <Select size="large" placeholder="Select Status" onChange={this.changeScoreOptions}>
//                                     <Select.Option value="Completed">Completed</Select.Option>
//                                     <Select.Option value="Pursuing">Pursuing</Select.Option>
//                                 </Select>
//                             )}
//                         </Form.Item>
//                     </Col>
//                     <Col span={6}>
//                         <Form.Item label={<span style={{ fontWeight: 600 }}>Country of Study</span>}>
//                             {getFieldDecorator(`${idPrefix}_country`, { initialValue: defaultCountry, rules: [{ required: true, message: "Select country" }] })(
//                                 <Select size="large" showSearch optionFilterProp='children' placeholder="Select Country">
//                                     {countries.map(c => <Select.Option key={c._id} value={c.display}>{c.display}</Select.Option>)}
//                                 </Select>
//                             )}
//                         </Form.Item>
//                     </Col>
//                     <Col span={6}>
//                         <Form.Item label={<span style={{ fontWeight: 600 }}>State of Study</span>}>
//                             {getFieldDecorator(`${idPrefix}_state`, { rules: [{ required: true, message: "Select state" }] })(
//                                 <Select size="large" showSearch optionFilterProp='children' placeholder="Select State">
//                                     {states.map(s => <Select.Option key={s._id} value={s._id}>{s.display}</Select.Option>)}
//                                 </Select>
//                             )}
//                         </Form.Item>
//                     </Col>
//                     <Col span={6}>
//                         <Form.Item label={<span style={{ fontWeight: 600 }}>Level of Study</span>}>
//                             {isAdditional ? (
//                                 getFieldDecorator(`${idPrefix}_level`, { rules: [{ required: true, message: "Select level" }] })(
//                                     <Select showSearch optionFilterProp='children' size="large" placeholder="Select Level of Study">
//                                         {additionalLevelOptions.map(level => (
//                                             <Select.Option key={level} value={level}>{level}</Select.Option>
//                                         ))}
//                                     </Select>
//                                 )
//                             ) : (
//                                 getFieldDecorator(`${idPrefix}_level`, { initialValue: title })(
//                                     <Input size="large" disabled />
//                                 )
//                             )}
//                         </Form.Item>
//                     </Col>
//                 </Row>

//                 <Row gutter={16}>
//                     <Col span={12}>
//                         <Form.Item label={<span style={{ fontWeight: 600 }}>Name of University / Board</span>}>
//                             {getFieldDecorator(`${idPrefix}_institution`, { rules: [{ required: true, message: "Enter name of institution" }] })(
//                                 <Input size="large" placeholder="Enter Name of University / Board" />
//                             )}
//                         </Form.Item>
//                     </Col>
//                     <Col span={12}>
//                         <Form.Item label={<span style={{ fontWeight: 600 }}>Qualification / Degree Awarded</span>}>
//                             {getFieldDecorator(`${idPrefix}_degree`, { rules: [{ required: true, message: "Enter qualification awarded" }] })(
//                                 <Input size="large" placeholder="Enter Qualification Achieved / Degree Awarded" />
//                             )}
//                         </Form.Item>
//                     </Col>
//                 </Row>

//                 <Row gutter={16}>
//                     <Col span={6}>
//                         <Form.Item label={<span style={{ fontWeight: 600 }}>City of Study</span>}>
//                             {getFieldDecorator(`${idPrefix}_city`, { rules: [{ required: true, message: "Enter city" }] })(
//                                 <Input size="large" placeholder="Enter City of Study" />
//                             )}
//                         </Form.Item>
//                     </Col>
//                     <Col span={6}>
//                         <Form.Item label={<span style={{ fontWeight: 600 }}>Grading System</span>}>
//                             {getFieldDecorator(`${idPrefix}_gradingSystem`, { rules: [{ required: !isPursuing, message: "Select system" }] })(
//                                 <Select showSearch optionFilterProp='children' size="large" placeholder="Select Grading System" onChange={this.changeScoreOptions}>
//                                     <Select.Option value="Percentage">Percentage</Select.Option>
//                                     <Select.Option value="CGPA 10.0 Scale">CGPA 10.0 Scale</Select.Option>
//                                     <Select.Option value="GPA 4.0 Scale">GPA 4.0 Scale</Select.Option>
//                                     <Select.Option value="Letter Grade">Letter Grade</Select.Option>
//                                     <Select.Option value="IB Grade">IB Grade</Select.Option>
//                                 </Select>
//                             )}
//                         </Form.Item>
//                     </Col>
//                     <Col span={6}>
//                         <Form.Item label={<span style={{ fontWeight: 600 }}>Percentage / Score</span>}>
//                             {getFieldDecorator(`${idPrefix}_score`, { rules: [{ required: !isPursuing, message: "Select score" }] })(
//                                 <Select size="large" showSearch optionFilterProp='children' placeholder="Select Score">
//                                     {gradingSystemScores.map(s => <Select.Option key={s.key} value={s.key}>{s.display}</Select.Option>)}
//                                 </Select>
//                             )}
//                         </Form.Item>
//                     </Col>
//                     <Col span={6}>
//                         <Form.Item label={<span style={{ fontWeight: 600 }}>Primary Language of Instruction</span>}>
//                             {getFieldDecorator(`${idPrefix}_language`, { initialValue: "English", rules: [{ required: true, message: "Enter language" }] })(
//                                 <Input size="large" placeholder="Enter Language" />
//                             )}
//                         </Form.Item>
//                     </Col>
//                 </Row>

//                 <Row gutter={16}>
//                     <Col span={12}>
//                         <Form.Item label={<span style={{ fontWeight: 600 }}>Start Date</span>}>
//                             {getFieldDecorator(`${idPrefix}_startDate`, { rules: [{ required: true, message: "Select start date" }] })(
//                                 <DatePicker size="large" style={{ width: '100%' }} format="DD/MM/YYYY" placeholder="Select Start Date" />
//                             )}
//                         </Form.Item>
//                     </Col>
//                     <Col span={12}>
//                         <Form.Item label={<span style={{ fontWeight: 600 }}>End Date</span>}>
//                             {getFieldDecorator(`${idPrefix}_endDate`, { rules: [{ required: true, message: "Select end date" }] })(
//                                 <DatePicker size="large" style={{ width: '100%' }} format="DD/MM/YYYY" placeholder="Select End Date" />
//                             )}
//                         </Form.Item>
//                     </Col>
//                 </Row>

//                 {/* <div style={{ display: "flex", justifyContent: "flex-end" }}>
//                     <Button type="primary" size="large" style={{ minWidth: 100, borderRadius: 6, fontWeight: 600 }}>
//                         Save
//                     </Button>
//                 </div> */}
//             </div>
//         );
//     }
// }
class QualificationCard extends React.Component {
    state = {
        trigger: 0
    };

    changeScoreOptions = () => {
        this.setState({ trigger: Math.random() });
    };

    render() {
        const {
            title,
            icon,
            color = "#1890ff",
            bgColor = "#e6f7ff",
            form,
            idPrefix,
            countries = [],
            states = [],
            defaultCountry = undefined,
            onRemove = null,
            isAdditional = false,
            additionalLevelOptions = []
        } = this.props;

        const { getFieldDecorator } = form;

        let gradingSystem = form.getFieldValue(`${idPrefix}_gradingSystem`);
        let qualStatus = form.getFieldValue(`${idPrefix}_qualificationStatus`);
        let isPursuing = qualStatus === "Pursuing";

        // Hide stream field for 10th Standard / Matriculation
        const isTenth = idPrefix === "tenth" || idPrefix === "10th" || title.toLowerCase().includes("10th") || title.toLowerCase().includes("matric");

        let gradingSystemScores = [];
        if (gradingSystem === "Percentage") {
            for (let i = 30; i <= 100; i++) {
                gradingSystemScores.push({ key: `${i}`, display: `${i}` });
            }
        } else if (gradingSystem === "CGPA 10.0 Scale") {
            for (let i = 0; i < 10; i++) {
                for (let d = 0; d < 10; d++) {
                    gradingSystemScores.push({ key: `${i}.${d}`, display: `${i}.${d}` });
                }
            }
            gradingSystemScores.push({ key: `10`, display: `10` });
        } else if (gradingSystem === "GPA 4.0 Scale") {
            gradingSystemScores = [
                { key: "1", display: "1" }, { key: "1.3", display: "1.3" }, { key: "1.7", display: "1.7" },
                { key: "2", display: "2" }, { key: "2.3", display: "2.3" }, { key: "2.5", display: "2.5" },
                { key: "2.7", display: "2.7" }, { key: "2.75", display: "2.75" }, { key: "2.8", display: "2.8" },
                { key: "3", display: "3" }, { key: "3.1", display: "3.1" }, { key: "3.2", display: "3.2" },
                { key: "3.3", display: "3.3" }, { key: "3.4", display: "3.4" }, { key: "3.5", display: "3.5" },
                { key: "3.6", display: "3.6" }, { key: "3.7", display: "3.7" }, { key: "3.8", display: "3.8" },
                { key: "3.9", display: "3.9" }, { key: "4", display: "4" }
            ];
        } else if (gradingSystem === "Letter Grade") {
            gradingSystemScores = [
                { key: "A+", display: "A+" }, { key: "A", display: "A" }, { key: "A-", display: "A-" },
                { key: "B+", display: "B+" }, { key: "B", display: "B" }, { key: "B-", display: "B-" },
                { key: "C+", display: "C+" }, { key: "C", display: "C" }, { key: "C-", display: "C-" },
                { key: "D+", display: "D+" }, { key: "D", display: "D" }
            ];
        } else if (gradingSystem === "IB Grade") {
            gradingSystemScores = [
                { key: "3", display: "3" }, { key: "4", display: "4" },
                { key: "5", display: "5" }, { key: "6", display: "6" }, { key: "7", display: "7" }
            ];
        }

        return (
            <div style={{ background: "#fff", padding: "20px", borderRadius: "10px", border: "1px solid #f0f0f0", marginBottom: 20, boxShadow: "0 1px 3px rgba(0,0,0,0.02)", borderLeft: `4px solid ${color}` }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <SectionTitle icon={icon} title={title} color={color} bgColor={bgColor} />
                    {onRemove && (
                        <Button type="link" onClick={onRemove} style={{ color: "#ff4d4f", fontWeight: 600 }}>
                            <Icon type="delete" /> Remove
                        </Button>
                    )}
                </div>

                <Row gutter={16}>
                    <Col span={6}>
                        <Form.Item label={<span style={{ fontWeight: 600 }}>Qualification Status</span>}>
                            {getFieldDecorator(`${idPrefix}_qualificationStatus`, { rules: [{ required: true, message: "Select status" }] })(
                                <Select size="large" placeholder="Select Status" onChange={this.changeScoreOptions}>
                                    <Select.Option value="Completed">Completed</Select.Option>
                                    <Select.Option value="Pursuing">Pursuing</Select.Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label={<span style={{ fontWeight: 600 }}>Country of Study</span>}>
                            {getFieldDecorator(`${idPrefix}_country`, { initialValue: defaultCountry, rules: [{ required: true, message: "Select country" }] })(
                                <Select size="large" showSearch optionFilterProp='children' placeholder="Select Country">
                                    {countries.map(c => <Select.Option key={c._id} value={c.display}>{c.display}</Select.Option>)}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label={<span style={{ fontWeight: 600 }}>State of Study</span>}>
                            {getFieldDecorator(`${idPrefix}_state`, { rules: [{ required: true, message: "Select state" }] })(
                                <Select size="large" showSearch optionFilterProp='children' placeholder="Select State">
                                    {states.map(s => <Select.Option key={s._id} value={s._id}>{s.display}</Select.Option>)}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label={<span style={{ fontWeight: 600 }}>Level of Study</span>}>
                            {isAdditional ? (
                                getFieldDecorator(`${idPrefix}_level`, { rules: [{ required: true, message: "Select level" }] })(
                                    <Select showSearch optionFilterProp='children' size="large" placeholder="Select Level of Study">
                                        {additionalLevelOptions.map(level => (
                                            <Select.Option key={level} value={level}>{level}</Select.Option>
                                        ))}
                                    </Select>
                                )
                            ) : (
                                getFieldDecorator(`${idPrefix}_level`, { initialValue: title })(
                                    <Input size="large" disabled />
                                )
                            )}
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={!isTenth ? 8 : 12}>
                        <Form.Item label={<span style={{ fontWeight: 600 }}>Name of University / Board</span>}>
                            {getFieldDecorator(`${idPrefix}_institution`, { rules: [{ required: true, message: "Enter name of institution" }] })(
                                <Input size="large" placeholder="Enter Name of University / Board" />
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={!isTenth ? 8 : 12}>
                        <Form.Item label={<span style={{ fontWeight: 600 }}>Qualification / Degree Awarded</span>}>
                            {getFieldDecorator(`${idPrefix}_degree`, { rules: [{ required: true, message: "Enter qualification awarded" }] })(
                                <Input size="large" placeholder="Enter Qualification Achieved / Degree Awarded" />
                            )}
                        </Form.Item>
                    </Col>
                    {/* Stream select dropdown added for all qualifications except 10th */}
                    {!isTenth && (
                        <Col span={8}>
                            <Form.Item label={<span style={{ fontWeight: 600 }}>Stream / Field of Study</span>}>
                                {getFieldDecorator(`${idPrefix}_stream`, { rules: [{ required: true, message: "Select stream" }] })(
                                    <Select size="large" showSearch optionFilterProp='children' placeholder="Select Stream">
                                        <Select.Option value={'MEDICAL'}>MEDICAL</Select.Option>
                                        <Select.Option value={'NON-MEDICAL'}>NON-MEDICAL</Select.Option>
                                        <Select.Option value={'COMMERCE'}>COMMERCE</Select.Option>
                                        <Select.Option value={'ARTS'}>ARTS</Select.Option>
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    )}
                </Row>

                <Row gutter={16}>
                    <Col span={6}>
                        <Form.Item label={<span style={{ fontWeight: 600 }}>City of Study</span>}>
                            {getFieldDecorator(`${idPrefix}_city`, { rules: [{ required: true, message: "Enter city" }] })(
                                <Input size="large" placeholder="Enter City of Study" />
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label={<span style={{ fontWeight: 600 }}>Grading System</span>}>
                            {getFieldDecorator(`${idPrefix}_gradingSystem`, { rules: [{ required: !isPursuing, message: "Select system" }] })(
                                <Select showSearch optionFilterProp='children' size="large" placeholder="Select Grading System" onChange={this.changeScoreOptions}>
                                    <Select.Option value="Percentage">Percentage</Select.Option>
                                    <Select.Option value="CGPA 10.0 Scale">CGPA 10.0 Scale</Select.Option>
                                    <Select.Option value="GPA 4.0 Scale">GPA 4.0 Scale</Select.Option>
                                    <Select.Option value="Letter Grade">Letter Grade</Select.Option>
                                    <Select.Option value="IB Grade">IB Grade</Select.Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label={<span style={{ fontWeight: 600 }}>Percentage / Score</span>}>
                            {getFieldDecorator(`${idPrefix}_score`, { rules: [{ required: !isPursuing, message: "Select score" }] })(
                                <Select size="large" showSearch optionFilterProp='children' placeholder="Select Score">
                                    {gradingSystemScores.map(s => <Select.Option key={s.key} value={s.key}>{s.display}</Select.Option>)}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label={<span style={{ fontWeight: 600 }}>Primary Language of Instruction</span>}>
                            {getFieldDecorator(`${idPrefix}_language`, { initialValue: "English", rules: [{ required: true, message: "Enter language" }] })(
                                <Input size="large" placeholder="Enter Language" />
                            )}
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label={<span style={{ fontWeight: 600 }}>Start Date</span>}>
                            {getFieldDecorator(`${idPrefix}_startDate`, { rules: [{ required: true, message: "Select start date" }] })(
                                <DatePicker size="large" style={{ width: '100%' }} format="DD/MM/YYYY" placeholder="Select Start Date" />
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label={<span style={{ fontWeight: 600 }}>End Date</span>}>
                            {getFieldDecorator(`${idPrefix}_endDate`, { rules: [{ required: true, message: "Select end date" }] })(
                                <DatePicker size="large" style={{ width: '100%' }} format="DD/MM/YYYY" placeholder="Select End Date" />
                            )}
                        </Form.Item>
                    </Col>
                </Row>
            </div>
        );
    }
}

@Form.create()
class Form2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nextYears: [],
            allUsers: [],
            sourceOptions: [],
            haveEnglishTestScore: false,
            testType: '',
            testTypeList: [],
            testTypeArray: [],
            testTypeScore: [],
            speaking: 0,
            reading: 0,
            writing: 0,
            listening: 0,
            ieltsOverallScore: 0,
            ifApplicantHasEmail: null,
            haveBackgroundInformation: null,
            havePassport: null,
            sameAsPeramanentAddress: false,
            activeTab: "1"
        };
    }

    handleSubmitTab2 = (e) => {
        const { form } = this.props;
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                if (this.props.form2Fields.counsellorId !== valData.counsellorId) {
                    this.props.handleSubmitTab2(valData);
                } else {
                    const { oldCounsellorId, ...rest } = valData;
                    this.props.handleSubmitTab2(rest);
                }
                this.props.form.setFieldsValue({ oldCounsellorId: undefined });
            }
        });
    };

    getNextFiveYears = () => {
        let years = [];
        for (let i = 0; i <= 5; i++) {
            let year = new Date().getFullYear() + i;
            years.push(year.toString());
        }
        this.setState({ nextYears: years });
    }

    getAllTestTypes = async () => {
        let response = await Request.getAllTestTypes({ results: 1000, count: 1000 });
        if (response && response.data) {
            let testTypeList = [];
            let testTypeArray = [];
            response.data.map((testTypeData) => {
                testTypeList.push(testTypeData.testType);
                if (testTypeArray[testTypeData.testType] === undefined) {
                    testTypeArray[testTypeData.testType] = {};
                }
                testTypeArray[testTypeData.testType] = testTypeData;
            });
            this.setState({ testTypeList, testTypeArray });
        }
    }

    async componentDidMount() {
        this.getNextFiveYears();
        await this.getAllTestTypes();

        const { form, form2Fields, allUsers } = this.props;
        this.setState({ allUsers });
        setTimeout(() => {
            let completeData = form2Fields;
            let testTypeObject = this.state.testTypeArray[completeData && completeData.testType] !== undefined ? this.state.testTypeArray[completeData && completeData.testType] : {};
            let testTypeScore = [];
            if (testTypeObject.endNumber) {
                for (let index = testTypeObject.startNumber; index <= testTypeObject.endNumber; index += testTypeObject.numberStep) {
                    testTypeScore.push(index + '');
                }
            }
            this.setState({ testTypeScore, testType: completeData.testType });
            if (completeData.haveEnglishTestScore === "Yes" || completeData.haveEnglishTestScore === true) {
                this.setState({ haveEnglishTestScore: true });
            }

            form.setFieldsValue({
                testType: completeData.testType,
                haveEnglishTestScore: completeData.haveEnglishTestScore === true ? "Yes" : (completeData.haveEnglishTestScore === false ? "No" : completeData.haveEnglishTestScore),
                ieltsOverallScore: completeData.ieltsOverallScore,
                whichYearPlanningToGo: completeData.whichYearPlanningToGo ? completeData.whichYearPlanningToGo.toString() : undefined,
                leadToIeltsCenter: completeData.leadToIeltsCenter,
                smsToStudent: completeData.smsToStudent,
                mailToStudent: completeData.mailToStudent,
                enqType: completeData.enqType,
                counsellorId: completeData.counsellorId,
                subCounsellorId: completeData && completeData.subCounsellorId,
                reading: completeData && completeData.reading,
                writing: completeData && completeData.writing,
                speaking: completeData && completeData.speaking,
                listening: completeData && completeData.listening,
            });
        }, 50);
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.form2Fields) !== JSON.stringify(this.props.form2Fields)) {
            let completeData = this.props.form2Fields;
            if (completeData) {
                let testTypeObject = this.state.testTypeArray[completeData && completeData.testType] !== undefined ? this.state.testTypeArray[completeData && completeData.testType] : {};
                let testTypeScore = [];
                if (testTypeObject && testTypeObject.endNumber) {
                    for (let index = testTypeObject.startNumber; index <= testTypeObject.endNumber; index += testTypeObject.numberStep) {
                        testTypeScore.push(index + '');
                    }
                }
                this.setState({ testTypeScore, testType: completeData.testType });
                if (completeData.haveEnglishTestScore === "Yes" || completeData.haveEnglishTestScore === true) {
                    this.setState({ haveEnglishTestScore: true });
                }

                this.props.form.setFieldsValue({
                    testType: completeData.testType,
                    haveEnglishTestScore: completeData.haveEnglishTestScore === true ? "Yes" : (completeData.haveEnglishTestScore === false ? "No" : completeData.haveEnglishTestScore),
                    ieltsOverallScore: completeData.ieltsOverallScore,
                    whichYearPlanningToGo: completeData.whichYearPlanningToGo ? completeData.whichYearPlanningToGo.toString() : undefined,
                    leadToIeltsCenter: completeData.leadToIeltsCenter,
                    smsToStudent: completeData.smsToStudent,
                    mailToStudent: completeData.mailToStudent,
                    enqType: completeData.enqType,
                    counsellorId: completeData.counsellorId,
                    subCounsellorId: completeData && completeData.subCounsellorId,
                    reading: completeData && completeData.reading,
                    writing: completeData && completeData.writing,
                    speaking: completeData && completeData.speaking,
                    listening: completeData && completeData.listening,
                });
            }
        }
    }

    render() {
        let { testTypeScore, testTypeList, testTypeArray } = this.state;
        const { form: { getFieldDecorator } } = this.props;

        return (
            <Form onSubmit={this.handleSubmitTab2} layout="vertical">
                <div style={{ background: "#fff", padding: "20px", borderRadius: "10px", border: "1px solid #f0f0f0", marginBottom: 20, boxShadow: "0 1px 3px rgba(0,0,0,0.02)", borderLeft: "4px solid #1890ff" }}>
                    <SectionTitle icon="global" title="Study Abroad Information" color="#1890ff" bgColor="#e6f7ff" />
                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item label={<span style={{ fontWeight: 600 }}>Year Planning To Go</span>}>
                                {getFieldDecorator("whichYearPlanningToGo")(
                                    <Select showSearch optionFilterProp='children' size="large" placeholder="Select Year">
                                        {this.state.nextYears.map(y => <Select.Option key={y} value={y}>{y}</Select.Option>)}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label={<span style={{ fontWeight: 600 }}>Do you have an English test score?</span>}>
                                {getFieldDecorator("haveEnglishTestScore")(
                                    <Select showSearch optionFilterProp='children' size="large" placeholder="Select Score Status" onChange={v => this.setState({ haveEnglishTestScore: v === "Yes" })}>
                                        <Select.Option value="Yes">Yes</Select.Option>
                                        <Select.Option value="Preparing">Preparing</Select.Option>
                                        <Select.Option value="Will Plan Soon">Will Plan Soon</Select.Option>
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        {this.state.haveEnglishTestScore && (
                            <Col span={8}>
                                <Form.Item label={<span style={{ fontWeight: 600 }}>Select Test Type</span>}>
                                    {getFieldDecorator("testType", { rules: [{ required: true, message: "Select test type" }] })(
                                        <Select showSearch optionFilterProp='children' size="large" placeholder="Select Test Type" onChange={v => {
                                            let testTypeObject = testTypeArray[v] !== undefined ? testTypeArray[v] : {};
                                            let testTypeScore = [];
                                            if (testTypeObject.endNumber) {
                                                for (let index = testTypeObject.startNumber; index <= testTypeObject.endNumber; index += testTypeObject.numberStep) {
                                                    testTypeScore.push(index + '');
                                                }
                                            }
                                            this.setState({ testType: v, testTypeScore });
                                        }}>
                                            {testTypeList.map(t => <Select.Option key={t} value={t}>{t}</Select.Option>)}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        )}
                    </Row>

                    {this.state.haveEnglishTestScore && (
                        <Row gutter={16}>
                            <Col span={6}>
                                <Form.Item label={<span style={{ fontWeight: 600 }}>Speaking Score</span>}>
                                    {getFieldDecorator("speaking")(
                                        <Select showSearch optionFilterProp='children' size="large" disabled={!this.state.testType} placeholder="Score">
                                            {testTypeScore.map(s => <Select.Option key={s} value={s}>{s}</Select.Option>)}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label={<span style={{ fontWeight: 600 }}>Listening Score</span>}>
                                    {getFieldDecorator("listening")(
                                        <Select showSearch optionFilterProp='children' size="large" disabled={!this.state.testType} placeholder="Score">
                                            {testTypeScore.map(s => <Select.Option key={s} value={s}>{s}</Select.Option>)}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label={<span style={{ fontWeight: 600 }}>Writing Score</span>}>
                                    {getFieldDecorator("writing")(
                                        <Select showSearch optionFilterProp='children' size="large" disabled={!this.state.testType} placeholder="Score">
                                            {testTypeScore.map(s => <Select.Option key={s} value={s}>{s}</Select.Option>)}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label={<span style={{ fontWeight: 600 }}>Reading Score</span>}>
                                    {getFieldDecorator("reading")(
                                        <Select showSearch optionFilterProp='children' size="large" disabled={!this.state.testType} placeholder="Score">
                                            {testTypeScore.map(s => <Select.Option key={s} value={s}>{s}</Select.Option>)}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    )}

                    <Row gutter={16}>
                        {this.state.haveEnglishTestScore && (
                            <Col span={8}>
                                <Form.Item label={<span style={{ fontWeight: 600 }}>Overall Score</span>}>
                                    {getFieldDecorator("ieltsOverallScore")(
                                        <Select showSearch optionFilterProp='children' size="large" disabled={!this.state.testType} placeholder="Overall">
                                            {testTypeScore.map(s => <Select.Option key={s} value={s}>{s}</Select.Option>)}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        )}
                        <Col span={8}>
                            <Form.Item label={<span style={{ fontWeight: 600 }}>Study Level</span>}>
                                {getFieldDecorator("enqType", { rules: [{ required: true, message: "Select study level" }] })(
                                    <Select showSearch optionFilterProp='children' size="large" placeholder="Select Level">
                                        <Select.Option value="Under Graduate">Under Graduate</Select.Option>
                                        <Select.Option value="Post Graduate">Post Graduate</Select.Option>
                                        <Select.Option value="Schooling">Schooling</Select.Option>
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button type="primary" htmlType="submit" size="large" loading={this.props.loading} style={{ borderRadius: 6, minWidth: 160, fontWeight: 600 }}>
                        Save Language Proficiency Info
                    </Button>
                </div>
            </Form>
        );
    }
}

@Form.create()
class EditInquiryV2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allow: null,
            cardLoading: true,
            showSave: 1,
            edited: false,
            completeData: null,
            modeArr: [],
            countryArr: [],
            countryFieldArr: [],
            statesData: [],
            citiesData: [],
            phoneCodes: [],
            dealingCountryArr: [],
            dealingCountryFieldArr: [],
            dealingPhoneCodes: [],
            dealingCountryPhoneCodes: {},
            totalPreference: [],
            city: null,
            country: null,
            gapTotal: '',
            showParentField: false,
            list: [],
            allUsers: [],
            activeTab: "1",
            totalData: [],
            totalData1: [],
            imageSrc: null,
            showWebCam: false,
            allEmployees: [],
            allMembers: [],
            showSourceModal: false,
            maritalArr: [],
            genderArr: [],
            testTypeList: [],
            testTypeArray: [],
            testTypeScore: [],

            highestEducationLevel: undefined,
            countryOfEducation: undefined,
            additionalQualifications: [],

            showWorkExpForm: false,
            isCurrentlyWorkingHere: false,

            ifWhatsAppNumberIsDifferentSwitch: false,
            ifApplicantHasEmail: true,
            havePassport: false,
            applicantCitizenMoreCountrySwitch: false,
            applicantLivingStudyingAnyOtherCountrySwitch: false,
            applicantAppliedAnyTypeImmigrationCountryIdSwitch: false,
            applicantVisaRefusalCountryIdSwitch: false,
            applicantSufferMedicalCondition: false,
            applicantConvictedCriminalOffence: false,
        };
        this.loadCountries();
        this.loadDealingCountries();
    }

    callbackForHandleSubmitTab2 = async (valData) => {
        valData.tab = "tab2";
        const { dispatch } = this.props;
        dispatch(showLoader());

        let formData = new FormData();
        formData.append("values", JSON.stringify(valData));
        formData.append("_id", this.state.inquiryId);

        let x = await Request.updateInquiryV2(this.state.inquiryId, formData);
        dispatch(hideLoader());
        if (!x.error) {
            notification.success({ message: "Inquiry Abroad Information Updated Successfully" });
            this.setFormValues(this.state.inquiryId);
        } else {
            notification.error({ message: "Error Saving", description: x.msg });
        }
    };

    getAllTestTypes = async () => {
        let response = await Request.getAllTestTypes({ results: 1000, count: 1000 });
        if (response && response.data) {
            let testTypeList = [];
            let testTypeArray = [];
            response.data.map((testTypeData) => {
                testTypeList.push(testTypeData.testType);
                if (testTypeArray[testTypeData.testType] === undefined) {
                    testTypeArray[testTypeData.testType] = {};
                }
                testTypeArray[testTypeData.testType] = testTypeData;
            });
            this.setState({ testTypeList, testTypeArray });
        }
    }

    calculateGap = async () => {
        let gapTotal = null;
        let totalGapInMonths = 0;
        let totalGapInYears = 0;
        let { list, totalData1 } = this.state;
        let currentDate = moment();
        if (list && list.length > 0 && !totalData1.length) {
            list.sort((left, right) => moment.utc(left.from, "MM-YYYY").diff(moment.utc(right.from, "MM-YYYY")));
            let lastQualificationEndDate = moment(list[list.length - 1].to, "MM-YYYY").endOf('month');
            totalGapInYears += currentDate.diff(lastQualificationEndDate, 'years');
            totalGapInMonths += currentDate.diff(lastQualificationEndDate, 'months') % 12;
        } else if (totalData1 && totalData1.length) {
            let jobList = _.clone(totalData1);
            jobList.sort((left, right) => moment.utc(left.from, "MM-YYYY").diff(moment.utc(right.from, "MM-YYYY")));
            let lastJobEndDate = moment(jobList[jobList.length - 1].to, "MM-YYYY").endOf('month');
            totalGapInYears += currentDate.diff(lastJobEndDate, 'years');
            totalGapInMonths += currentDate.diff(lastJobEndDate, 'months') % 12;
        }

        if (totalGapInMonths > 11) {
            totalGapInYears += moment.duration(totalGapInMonths, 'months').asYears();
            totalGapInMonths = totalGapInMonths % 12;
        }
        gapTotal = totalGapInYears > 0 || totalGapInMonths > 0
            ? `${totalGapInYears > 0 ? totalGapInYears + (totalGapInYears > 1 ? " Years " : " Year ") : ""}${totalGapInMonths > 0 ? totalGapInMonths + (totalGapInMonths > 1 ? " Months" : " Month") : ""}`
            : "No Gap";
        this.setState({ gapTotal });
    }

    callback = (key) => {
        this.setState({ activeTab: key });
        let { completeData, twoOpened, fourOpened } = this.state;
        if (key === '2' && !twoOpened) {
            this.setState({ twoOpened: true });
            const { form } = this.props;
            setTimeout(() => {
                let testTypeObject = this.state && this.state.testTypeArray[completeData.testType] !== undefined ? this.state.testTypeArray[completeData && completeData.testType] : {};
                let testTypeScore = [];
                if (testTypeObject.endNumber) {
                    for (let index = testTypeObject.startNumber; index <= testTypeObject.endNumber; index += testTypeObject.numberStep) {
                        testTypeScore.push(index + '');
                    }
                }
                this.setState({ testTypeScore });
                form.setFieldsValue({
                    testType: completeData && completeData.testType,
                    haveEnglishTestScore: completeData && completeData.haveEnglishTestScore,
                    ieltsOverallScore: completeData && completeData.profile && completeData.profile.overAllScore ? parseFloat(completeData.profile.overAllScore) : null,
                    whichYearPlanningToGo: completeData && completeData.whichYearPlanningToGo,
                    leadToIeltsCenter: completeData && completeData.leadToIeltsCenter,
                    smsToStudent: completeData && completeData.smsToStudent,
                    mailToStudent: completeData && completeData.mailToStudent,
                    enqType: completeData && completeData.enqType,
                    counsellorId: completeData.counsellorId ? (completeData.counsellorId._id || completeData.counsellorId) : "",
                    subCounsellorId: completeData.subCounsellorId ? completeData.subCounsellorId : [],
                    reading: completeData && completeData.profile && completeData.profile.reading,
                    writing: completeData && completeData.profile && completeData.profile.writing,
                    speaking: completeData && completeData.profile && completeData.profile.speaking,
                    listening: completeData && completeData.profile && completeData.profile.listening,
                });
            }, 300);
        }
        if (key === '4' && !fourOpened) {
            this.setState({ fourOpened: true });
            if (completeData && completeData.gapTotal) {
                this.setState({ gapTotal: completeData.gapTotal });
            }
            this.populateQualifications(completeData);
        }
    };

    populateQualifications = (completeData) => {
        let qualList = completeData && completeData.profile && completeData.profile.newQualification ? completeData.profile.newQualification : [];
        let formVals = {};
        let maxLevel = null;
        let countryEd = null;
        let additionalQuals = [];

        qualList.forEach((q, index) => {
            let pfx = "";
            let level = q.level || q.qualification;
            if (level === "Postgraduate") { pfx = "pg"; if (!maxLevel) maxLevel = "Postgraduate"; }
            else if (level === "Undergraduate") { pfx = "ug"; if (maxLevel !== "Postgraduate") maxLevel = "Undergraduate"; }
            else if (level === "Grade 12th or equivalent") { pfx = "g12"; if (!maxLevel || maxLevel === "Grade 10th or equivalent") maxLevel = "Grade 12th or equivalent"; }
            else if (level === "Grade 10th or equivalent") { pfx = "g10"; if (!maxLevel) maxLevel = "Grade 10th or equivalent"; }
            else {
                let addId = Date.now() + index;
                additionalQuals.push({ id: addId });
                pfx = `add_${addId}`;
            }

            if (pfx) {
                formVals[`${pfx}_country`] = q.studyCountry || q.country;
                formVals[`${pfx}_state`] = q.state;
                formVals[`${pfx}_level`] = level;
                formVals[`${pfx}_institution`] = q.university || q.board || q.institution;
                formVals[`${pfx}_degree`] = q.degreeType || q.degree;
                formVals[`${pfx}_city`] = q.city;
                formVals[`${pfx}_gradingSystem`] = q.gradingSystem;
                formVals[`${pfx}_score`] = q.score || q.percentage;
                formVals[`${pfx}_stream`] = q.stream;
                formVals[`${pfx}_language`] = q.primaryInstructionLanguage || q.language;
                formVals[`${pfx}_qualificationStatus`] = q.qualificationStatus;

                let startDateRaw = q.from || q.startDate;
                let endDateRaw = q.to || q.endDate;

                if (startDateRaw) {
                    let m = Moment(startDateRaw, ["MM-YYYY", "YYYY-MM-DD", Moment.ISO_8601]);
                    formVals[`${pfx}_startDate`] = m.isValid() ? m : null;
                }
                if (endDateRaw) {
                    let m = Moment(endDateRaw, ["MM-YYYY", "YYYY-MM-DD", Moment.ISO_8601]);
                    formVals[`${pfx}_endDate`] = m.isValid() ? m : null;
                }

                if (!countryEd && (q.studyCountry || q.country)) countryEd = q.studyCountry || q.country;
            }
        });

        this.setState({
            list: qualList,
            totalData1: completeData && completeData.profile && completeData.profile.jobDetails ? completeData.profile.jobDetails : [],
            highestEducationLevel: maxLevel || this.state.highestEducationLevel,
            countryOfEducation: countryEd || this.state.countryOfEducation,
            additionalQualifications: additionalQuals
        }, () => {
            if (maxLevel) formVals.highestEducationLevel = maxLevel;
            if (countryEd) formVals.countryOfEducation = countryEd;
            this.props.form.setFieldsValue(formVals);
        });
    };

    handleSubmitTab1 = (e) => {
        const { dispatch, form } = this.props;
        e.preventDefault();

        const tab1Fields = [
            'studentName', 'dateOfBirth', 'gender', 'maritalStatus', 'mode', 'howToContact', 'contactPreferredTime',
            'accompaniedByParentGuardian', 'parentGuardianName', 'addressCountryId', 'countryCode', 'mobile',
            'parentMobile', 'ifApplicantHasEmail', 'emailId', 'ifWhatsAppNumberIsDifferentSwitch', 'whatsappCountryCode',
            'whatsappNumber', 'address', 'permanentAddressCountry', 'permanentAddressState', 'permanentAddressCity',
            'sameAsPeramanentAddress', 'havePassport', 'passport', 'nationality', 'citizenship',
            'applicantCitizenMoreCountrySwitch', 'applicantLivingStudyingAnyOtherCountrySwitch',
            'haveBackgroundInformation', 'emergencyName', 'emergencyCountryCode', 'emergencyMobile',
            'landline', 'emergencyEmail', 'emergencyRelationShip', 'location', 'associativePartnerId',
            'employeeId', 'referralName', 'membershipDetail', 'telecallerId', 'operationManagerId', 'counsellorId', 'subCounsellorId'
        ];

        form.validateFieldsAndScroll(tab1Fields, async (err, valData) => {
            if (!err) {
                valData.tab = "tab1";
                valData.profile = {
                    passportNumber: valData.passport,
                    address: valData.address,
                    landline: valData.landline,
                };
                delete valData.passport;
                delete valData.address;
                delete valData.landline;

                dispatch(showLoader());
                let formData = new FormData();
                formData.append("values", JSON.stringify(valData));
                formData.append("_id", this.state.inquiryId);
                if (this.state.imageSrc) {
                    formData.append("profileImage", this.state.imageSrc);
                }
                let x = await Request.updateInquiryV2(this.state.inquiryId, formData);
                dispatch(hideLoader());
                if (!x.error) {
                    notification.success({ message: "Inquiry Basic Info Updated Successfully" });
                    this.setFormValues(this.state.inquiryId);
                } else {
                    notification.error({ message: "Error Saving", description: x.msg });
                }
            }
        });
    };

    handleSubmitTab3 = async (e) => {
        const { dispatch } = this.props;
        e.preventDefault();
        let valData = {};
        valData.tab = "tab3";

        let data = [];
        _.each(this.state.totalPreference, (item) => {
            let abc = {};
            abc.country = item.country.display || item.country.countryName || item.country;
            abc.state = item.prefState ? (item.prefState.display || item.prefState.stateName || item.prefState) : (item.state ? (item.state.display || item.state.stateName || item.state) : "");
            abc.countryId = item.country._id || item.countryId;
            abc.stateId = item.prefState ? (item.prefState._id || item.prefStateId) : (item.stateId || "");
            data.push(abc);
        });
        valData.totalPreference = data;

        if (!valData.totalPreference.length) {
            notification.error({ message: "Please enter at least 1 Preference." });
            return;
        }

        dispatch(showLoader());
        let formData = new FormData();
        formData.append("values", JSON.stringify(valData));
        formData.append("_id", this.state.inquiryId);

        let x = await Request.updateInquiryV2(this.state.inquiryId, formData);
        dispatch(hideLoader());

        if (!x.error) {
            notification.success({ message: "Inquiry Preference Updated Successfully" });
            this.setFormValues(this.state.inquiryId);
        } else {
            notification.error({ message: "Error Saving", description: x.msg });
        }
    };

    handleSubmitTab4 = async (e) => {
        const { dispatch } = this.props;
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                let qualArray = [];
                const levelsMap = {
                    'pg': 'Postgraduate',
                    'ug': 'Undergraduate',
                    'g12': 'Grade 12th or equivalent',
                    'g10': 'Grade 10th or equivalent'
                };

                const showPostgradCard = values.highestEducationLevel === "Postgraduate";
                const showUndergradCard = showPostgradCard || values.highestEducationLevel === "Undergraduate";
                const showGrade12Card = showUndergradCard || values.highestEducationLevel === "Grade 12th or equivalent";
                const showGrade10Card = showGrade12Card || values.highestEducationLevel === "Grade 10th or equivalent";

                const activePrefixes = [];
                if (showPostgradCard) activePrefixes.push('pg');
                if (showUndergradCard) activePrefixes.push('ug');
                if (showGrade12Card) activePrefixes.push('g12');
                if (showGrade10Card) activePrefixes.push('g10');

                activePrefixes.forEach(pfx => {
                    if (values[`${pfx}_institution`]) {
                        qualArray.push({
                            _id: Moment().unix(),
                            level: levelsMap[pfx],
                            qualification: levelsMap[pfx],
                            studyCountry: values[`${pfx}_country`],
                            country: values[`${pfx}_country`],
                            state: values[`${pfx}_state`],
                            university: values[`${pfx}_institution`],
                            board: values[`${pfx}_institution`],
                            institution: values[`${pfx}_institution`],
                            degreeType: values[`${pfx}_degree`],
                            degree: values[`${pfx}_degree`],
                            city: values[`${pfx}_city`],
                            gradingSystem: values[`${pfx}_gradingSystem`],
                            score: values[`${pfx}_score`],
                            stream: values[`${pfx}_stream`],
                            percentage: values[`${pfx}_score`],
                            primaryInstructionLanguage: values[`${pfx}_language`],
                            language: values[`${pfx}_language`],
                            qualificationStatus: values[`${pfx}_qualificationStatus`],
                            from: values[`${pfx}_startDate`] ? values[`${pfx}_startDate`].format('MM-YYYY') : null,
                            to: values[`${pfx}_endDate`] ? values[`${pfx}_endDate`].format('MM-YYYY') : null,
                            startDate: values[`${pfx}_startDate`] ? values[`${pfx}_startDate`].format('YYYY-MM-DD') : null,
                            endDate: values[`${pfx}_endDate`] ? values[`${pfx}_endDate`].format('YYYY-MM-DD') : null,
                            qualificationStatus: "Completed"
                        });
                    }
                });

                this.state.additionalQualifications.forEach(addQual => {
                    const pfx = `add_${addQual.id}`;
                    if (values[`${pfx}_institution`]) {
                        qualArray.push({
                            _id: Moment().unix() + Math.floor(Math.random() * 1000),
                            level: values[`${pfx}_level`],
                            qualification: values[`${pfx}_level`],
                            studyCountry: values[`${pfx}_country`],
                            country: values[`${pfx}_country`],
                            state: values[`${pfx}_state`],
                            university: values[`${pfx}_institution`],
                            board: values[`${pfx}_institution`],
                            institution: values[`${pfx}_institution`],
                            degreeType: values[`${pfx}_degree`],
                            degree: values[`${pfx}_degree`],
                            city: values[`${pfx}_city`],
                            gradingSystem: values[`${pfx}_gradingSystem`],
                            score: values[`${pfx}_score`],
                            stream: values[`${pfx}_stream`],
                            percentage: values[`${pfx}_score`],
                            primaryInstructionLanguage: values[`${pfx}_language`],
                            language: values[`${pfx}_language`],
                            qualificationStatus: values[`${pfx}_qualificationStatus`],
                            from: values[`${pfx}_startDate`] ? values[`${pfx}_startDate`].format('MM-YYYY') : null,
                            to: values[`${pfx}_endDate`] ? values[`${pfx}_endDate`].format('MM-YYYY') : null,
                            startDate: values[`${pfx}_startDate`] ? values[`${pfx}_startDate`].format('YYYY-MM-DD') : null,
                            endDate: values[`${pfx}_endDate`] ? values[`${pfx}_endDate`].format('YYYY-MM-DD') : null,
                            qualificationStatus: "Completed"
                        });
                    }
                });

                values.tab = "tab4";
                values.qualification = qualArray;
                values.jobDetails = this.state.totalData1;
                values.gapTotal = this.state.gapTotal;

                dispatch(showLoader());
                let formData = new FormData();
                formData.append("values", JSON.stringify(values));
                formData.append("_id", this.state.inquiryId);

                let x = await Request.updateInquiryV2(this.state.inquiryId, formData);
                dispatch(hideLoader());

                if (!x.error) {
                    notification.success({ message: "Inquiry Qualification/Job Updated Successfully" });
                    this.setState({ list: qualArray });
                } else {
                    notification.error({ message: "Error Saving", description: x.msg });
                }
            }
        });
    };

    editWorkExperience = (item) => {
        const { form } = this.props;

        let workingFrom = item.from ? Moment(item.from, 'MM-YYYY') : null;
        let workingUpto = null;
        let currentlyWorkingHere = false;

        if (item.to === "Present" || item.to === "present") {
            currentlyWorkingHere = true;
        } else if (item.to) {
            workingUpto = Moment(item.to, 'MM-YYYY');
        }

        this.setState({
            showWorkExpForm: true,
            isCurrentlyWorkingHere: currentlyWorkingHere,
            totalData1: _.reject(this.state.totalData1, item)
        }, () => {
            this.calculateGap();
            setTimeout(() => {
                form.setFieldsValue({
                    orgNameAddress: item.company,
                    position: item.jobTitle,
                    jobProfile: item.contactPerson,
                    modeOfSalary: item.salaryMode,
                    workingFrom: workingFrom,
                    workingUpto: workingUpto,
                    currentlyWorkingHere: currentlyWorkingHere
                });
            }, 50);
        });
    };

    handleSubmitWorkExperience = (e) => {
        const { dispatch, form } = this.props;
        e.preventDefault();
        form.validateFields(async (err, values) => {
            if (!err) {
                let newJob = {
                    company: values.orgNameAddress,
                    jobTitle: values.position,
                    contactPerson: values.jobProfile,
                    salaryMode: values.modeOfSalary,
                    from: values.workingFrom ? values.workingFrom.format('MM-YYYY') : "",
                    to: values.currentlyWorkingHere ? "Present" : (values.workingUpto ? values.workingUpto.format('MM-YYYY') : ""),
                    phone: "",
                };

                let updatedJobList = [...this.state.totalData1, newJob];

                let payload = {
                    tab: "tab5",
                    jobDetails: updatedJobList,
                    gapTotal: this.state.gapTotal
                };

                dispatch(showLoader());
                let formData = new FormData();
                formData.append("values", JSON.stringify(payload));
                formData.append("_id", this.state.inquiryId);

                let x = await Request.updateInquiryV2(this.state.inquiryId, formData);
                dispatch(hideLoader());

                if (!x.error) {
                    notification.success({ message: "Work Experience Saved Successfully" });
                    this.setState({ totalData1: updatedJobList, showWorkExpForm: false });
                    form.resetFields(['orgNameAddress', 'position', 'jobProfile', 'modeOfSalary', 'workingFrom', 'workingUpto', 'currentlyWorkingHere']);
                } else {
                    notification.error({ message: "Error Saving", description: x.msg });
                }
            }
        });
    };

    setFormValues = async (inquiryId) => {
        const { form } = this.props;
        try {
            this.setState({ inquiryId: inquiryId, cardLoading: true });
            let { doc, allow } = await Request.getInquiryV2(inquiryId);

            if (doc && allow) {
                this.setState({ allow: true, cardLoading: false });
                if (doc.permanentAddressCountry || doc.currentAddressCountry) {
                    this.loadStates(doc.permanentAddressCountry || doc.currentAddressCountry);
                }
                if (doc.permanentAddressState || doc.currentAddressState) {
                    this.loadCitiesByState(doc.permanentAddressState || doc.currentAddressState);
                }
                if (doc.location === "Sub Agent") {
                    this.loadAssociativePartners(doc.location);
                    this.setState({ locationSet: true });
                }
                if (doc.location === "Employee Referral") {
                    this.loadEmployees();
                }
                if (doc.location === "Loyality Program") {
                    this.loadMembers();
                }

                this.setState({
                    havePassport: (doc.havePassport === "Yes" || doc.havePassport === true),
                    haveBackgroundInformation: (doc.haveBackgroundInformation === "Yes"),
                    sameAsPeramanentAddress: doc.sameAsPeramanentAddress,
                    ifApplicantHasEmail: (doc.ifApplicantHasEmail === "Yes"),
                    showParentField: (doc.accompaniedByParentGuardian === 'Yes'),
                    ifWhatsAppNumberIsDifferentSwitch: doc.ifWhatsAppNumberIsDifferentSwitch || false,
                    applicantCitizenMoreCountrySwitch: doc.applicantCitizenMoreCountrySwitch || false,
                    applicantLivingStudyingAnyOtherCountrySwitch: doc.applicantLivingStudyingAnyOtherCountrySwitch || false,
                    applicantAppliedAnyTypeImmigrationCountryIdSwitch: doc.applicantAppliedAnyTypeImmigrationCountryIdSwitch || false,
                    applicantVisaRefusalCountryIdSwitch: doc.applicantVisaRefusalCountryIdSwitch || false,
                    applicantSufferMedicalCondition: doc.applicantSufferMedicalCondition === "Yes",
                    applicantConvictedCriminalOffence: doc.applicantConvictedCriminalOffence === "Yes",
                    totalPreference: doc.totalPreference || [],
                    completeData: doc
                }, () => {
                    form.setFieldsValue({
                        studentName: doc.studentName,
                        gender: doc.gender,
                        dateOfBirth: doc.dateOfBirth ? Moment(doc.dateOfBirth) : null,
                        maritalStatus: doc.maritalStatus,
                        mode: doc.mode,
                        howToContact: doc.howToContact,
                        contactPreferredTime: doc.contactPreferredTime,
                        accompaniedByParentGuardian: doc.accompaniedByParentGuardian,
                        parentGuardianName: doc.parentGuardianName,
                        location: doc.location,
                        associativePartnerId: doc.associativePartnerId,
                        employeeId: doc.employeeId,
                        referralName: doc.referralName,
                        membershipDetail: doc.membershipDetail,
                        telecallerId: doc.telecallerId,
                        operationManagerId: doc.operationManagerId,
                        counsellorId: doc.counsellorId ? (doc.counsellorId._id || doc.counsellorId) : undefined,
                        subCounsellorId: doc.subCounsellorId || [],
                        addressCountryId: doc.addressCountryId,
                        countryCode: doc.countryCode,
                        mobile: doc.mobile ? parseInt(doc.mobile) : null,
                        parentMobile: doc.parentMobile ? parseInt(doc.parentMobile) : null,
                        watsupp: doc.watsupp ? parseInt(doc.watsupp) : null,
                        emailId: doc.emailId,
                        passport: doc.profile ? doc.profile.passportNumber : "",
                        address: doc.profile ? doc.profile.address : "",
                        permanentAddressCountry: doc.permanentAddressCountry,
                        permanentAddressState: doc.permanentAddressState,
                        permanentAddressCity: doc.permanentAddressCity,
                        sameAsPeramanentAddress: doc.sameAsPeramanentAddress,
                        currentAddress: doc.currentAddress,
                        currentAddressCountry: doc.currentAddressCountry,
                        currentAddressState: doc.currentAddressState,
                        currentAddressCity: doc.currentAddressCity,
                        nationality: doc.nationality,
                        citizenship: doc.citizenship,
                        emergencyName: doc.emergencyName,
                        emergencyCountryCode: doc.emergencyCountryCode,
                        emergencyEmail: doc.emergencyEmail,
                        emergencyRelationShip: doc.emergencyRelationShip,
                        landline: doc.profile ? doc.profile.landline : "",
                        havePassport: (doc.havePassport === "Yes" || doc.havePassport === true),
                        ifApplicantHasEmail: doc.ifApplicantHasEmail || "Yes",
                        ifWhatsAppNumberIsDifferentSwitch: doc.ifWhatsAppNumberIsDifferentSwitch || false,
                        haveBackgroundInformation: doc.haveBackgroundInformation || "No",
                        applicantAppliedAnyTypeImmigrationCountryIdSwitch: doc.applicantAppliedAnyTypeImmigrationCountryIdSwitch || false,
                        applicantAppliedAnyTypeImmigrationCountryId: doc.applicantAppliedAnyTypeImmigrationCountryId,
                        applicantSufferMedicalCondition: doc.applicantSufferMedicalCondition || "No",
                        applicantMedicalCondition: doc.applicantMedicalCondition,
                        applicantVisaRefusalCountryIdSwitch: doc.applicantVisaRefusalCountryIdSwitch || false,
                        applicantVisaRefusalCountryId: doc.applicantVisaRefusalCountryId,
                        applicantConvictedCriminalOffence: doc.applicantConvictedCriminalOffence || "No",
                        applicantCriminalOffence: doc.applicantCriminalOffence,
                        applicantCitizenMoreCountrySwitch: doc.applicantCitizenMoreCountrySwitch || false,
                        applicantCitizenMoreCountry: doc.applicantCitizenMoreCountry,
                        applicantLivingStudyingAnyOtherCountrySwitch: doc.applicantLivingStudyingAnyOtherCountrySwitch || false,
                        applicantLivingStudyingAnyOtherCountry: doc.applicantLivingStudyingAnyOtherCountry,
                        highestEducationLevel: doc.highestEducationLevel || undefined,
                        countryOfEducation: doc.countryOfEducation || undefined,
                    });
                    this.populateQualifications(doc);
                });
            } else {
                this.setState({ allow: false, cardLoading: false });
            }
        } catch (e) {
            console.log(e);
            this.setState({ allow: false, cardLoading: false });
        }
    };

    loadStates = async id => {
        Request.loadStates(id).then(daa => {
            this.setState({ statesData: daa.result.map(val => ({ id: val._id, _id: val._id, display: val.stateName })) });
        });
    }

    loadCitiesByState = async id => {
        Request.loadCities(id).then(data => {
            this.setState({ citiesData: data.result.map(val => ({ id: val._id, _id: val.cityId, display: val.cityName })) });
        });
    };

    loadDealingCountries = () => {
        Request.getDealingCountries({ results: 100, sortField: "countryName", sortOrder: "ascend" }).then((resp) => {
            let dealingPhoneCodes = [];
            let dealingCountryPhoneCodes = {};
            let dealingCountryFieldArr = [];
            if (resp && resp.data) {
                resp.data.forEach(vv => {
                    dealingCountryFieldArr.push({ _id: vv._id, display: vv.countryName });
                    if (vv.countryPhoneCode) {
                        dealingCountryPhoneCodes[vv._id] = vv.countryPhoneCode;
                        dealingPhoneCodes.push(vv.countryPhoneCode);
                    }
                });
            }
            this.setState({ dealingCountryArr: resp.data || [], dealingCountryFieldArr, dealingPhoneCodes, dealingCountryPhoneCodes });
        });
    }

    loadCountries = () => {
        Request.getCountriesWithoutAuth({ results: 100, sortField: "countryName", sortOrder: "ascend" }).then((resp) => {
            let countryFieldArr = [];
            let phoneCodes = [];
            if (resp && resp.data) {
                resp.data.forEach(vv => {
                    countryFieldArr.push({ _id: vv._id, display: vv.countryName });
                    if (vv.countryPhoneCode) phoneCodes.push(vv.countryPhoneCode);
                });
            }
            this.setState({ countryArr: resp.data || [], countryFieldArr, phoneCodes });
        });
    };

    loadCities = (countryId) => {
        Request.loadCitiesByCountry(countryId).then(data => this.setState({ cityArr: data.result }));
    };

    loadAssociativePartners = (source) => {
        if (source === "Sub Agent") {
            Request.loadSimpleBranch({ status: true, branchAssociatePartner: "Associate Partner", sortField: "branchName", results: 1000 }).then(data => {
                this.props.dispatch({ type: "SET_ALL_CP", data: data.data });
                this.setState({ locationSet: true });
            });
        } else {
            this.setState({ locationSet: false });
        }
    };

    showDrawer = () => this.setState({ visible: true });

    setRef = (webcam) => { this.webcam = webcam; };

    capture = () => {
        this.setState({ imageSrc: this.webcam.getScreenshot() });
    };

    onSave = (index) => {
        const { form } = this.props;
        let x = form.getFieldsValue(["qualification", "percentage", "maths", "english", "stream", "major", "passingYear", "backlogs", "degreeType"]);
        let editedData = [...this.state.list];
        editedData[index] = { ...x };
        this.setState({ list: editedData });
    };

    getAllSource = async () => {
        let response = await Request.getSourceDetails({ results: 1000, count: 1000 });
        this.setState({ modeArr: response.data ? response.data.map(s => s.sourceName) : [] });
    }

    loadEmployees = async (params) => {
        if (!params) params = {};
        params.sortField = 'dateOfJoining';
        params.sortOrder = 'ascend';
        params.active = true;
        params.count = 100000;
        params.results = 100000;
        params.userBranch = user && user.userBranch ? user.userBranch : null;
        let data = await Request.loadDeskUser({ ...params });
        let allEmployees = [];
        _.each(data.data, (employee) => {
            allEmployees.push({ id: employee._id, display: employee.name });
        });
        this.setState({ allEmployees });
    }

    loadMembers = async (params) => {
        if (!params) params = {};
        let data = await Request.getProgramMembers(params);
        let allMembers = [];
        _.each(data.data, (member) => {
            allMembers.push({ id: member._id, display: `${member.membershipCode}-${member.name}` });
        });
        this.setState({ allMembers });
    }

    deleteImage = async () => this.setState({ imageSrc: null });

    setFormTwoData() {
        let { completeData } = this.state;
        if (completeData) {
            return {
                testType: completeData.testType,
                haveEnglishTestScore: completeData.haveEnglishTestScore,
                ieltsOverallScore: completeData.profile && completeData.profile.overAllScore ? parseFloat(completeData.profile.overAllScore) : null,
                whichYearPlanningToGo: completeData.whichYearPlanningToGo,
                enqType: completeData.enqType,
                counsellorId: completeData.counsellorId ? (completeData.counsellorId._id || completeData.counsellorId) : "",
                subCounsellorId: completeData.subCounsellorId || [],
                reading: completeData.profile && completeData.profile.reading,
                writing: completeData.profile && completeData.profile.writing,
                speaking: completeData.profile && completeData.profile.speaking,
                listening: completeData.profile && completeData.profile.listening,
            };
        }
    }

    getAllGenders = async () => {
        let response = await Request.getGenderDetails({ results: 1000, count: 1000 });
        this.setState({ genderArr: response.data ? response.data.map(g => g.genderName) : [] });
    }

    getAllMaritalStatus = async () => {
        let response = await Request.getMaritalStatusDetails({ results: 1000, count: 1000 });
        this.setState({ maritalArr: response.data ? response.data.map(m => m.maritalStatus) : [] });
    }

    addAdditionalQualificationCard = () => {
        let newAdditions = [...this.state.additionalQualifications];
        newAdditions.push({ id: Date.now() });
        this.setState({ additionalQualifications: newAdditions });
    };

    removeAdditionalQualificationCard = (index) => {
        let newAdditions = [...this.state.additionalQualifications];
        newAdditions.splice(index, 1);
        this.setState({ additionalQualifications: newAdditions });
    };

    handleCountryOfEducationChange = (value) => {
        this.setState({ countryOfEducation: value });
        this.props.form.setFieldsValue({
            pg_country: value,
            ug_country: value,
            g12_country: value,
            g10_country: value,
        });
        this.state.additionalQualifications.forEach(addQual => {
            this.props.form.setFieldsValue({
                [`add_${addQual.id}_country`]: value
            });
        });
    };

    async componentDidMount() {
        this.setState({ cardLoading: true });
        await this.getAllSource();
        await this.getAllGenders();
        await this.getAllMaritalStatus();
        await this.getAllTestTypes();

        let { data: allUsers } = await Request.loadUser({ results: 10000, isCounsellor: true, active: true });
        let { data: telecallers } = await Request.loadUser({ results: 10000, isTelecaller: true, active: true });
        let { data: operationManagers } = await Request.loadUser({ results: 10000, isOperationManager: true, active: true });
        this.setState({ allUsers, telecallers, operationManagers });

        let searchParams = new URLSearchParams(this.props.search);
        let inquiryId = searchParams.get("id");
        this.setFormValues(inquiryId);
    }

    render() {
        const { allow, cardLoading, list, completeData, phoneCodes, dealingPhoneCodes, dealingCountryPhoneCodes = {}, highestEducationLevel, countryOfEducation, additionalQualifications, showWorkExpForm, isCurrentlyWorkingHere } = this.state;
        const { form: { getFieldDecorator } } = this.props;

        const hasRights = user && (user.isOperationManager || user.isAdministrator || user.isStateHead);
        const disableSource = (completeData && completeData.location) ? !hasRights : false;
        const disableSubAgent = (completeData && completeData.associativePartnerId) ? !hasRights : false;
        const disableEmployee = (completeData && completeData.employeeId) ? !hasRights : false;
        const disableReferral = (completeData && completeData.referralName) ? !hasRights : false;
        const disableMember = (completeData && completeData.membershipDetail) ? !hasRights : false;

        if (allow === null || cardLoading) {
            return (
                <div style={{ textAlign: 'center', padding: '120px 0', background: '#f8fafc', minHeight: '100vh' }}>
                    <Spin size="large" tip="Loading Inquiry Profile & Checking Permissions..." />
                </div>
            );
        }

        if (allow === false) {
            return (
                <Exception
                    type="404"
                    desc={"You do not have permission to view or edit this inquiry."}
                    linkElement={Link}
                    redirect={"/dashboard"}
                    backText={"Go To Homepage?"}
                />
            );
        }

        const preferenceColumns = [
            { title: "Country", key: "country", render: (val, record) => record.country ? (record.country.display || record.country.countryName || record.country) : "" },
            { title: "State", key: "state", render: (val, record) => record.state ? (record.state.display || record.state.stateName || record.state) : "" },
            {
                title: "Action", key: "action", render: (val, record) => (
                    <Button type="link" style={{ color: "#ff4d4f", padding: 0 }} onClick={() => {
                        let tt = this.state.totalPreference.filter(item => item !== record);
                        this.setState({ totalPreference: tt });
                    }}>
                        <Icon type="delete" />
                    </Button>
                )
            }
        ];

        const jobColumns = [
            { title: "Organisation & Address", dataIndex: "company", key: "company" },
            { title: "Position", dataIndex: "jobTitle", key: "jobTitle" },
            { title: "Job Profile", dataIndex: "contactPerson", key: "contactPerson" },
            { title: "Mode of Salary", dataIndex: "salaryMode", key: "salaryMode" },
            { title: "Working From", dataIndex: "from", key: "from" },
            { title: "Working Upto", dataIndex: "to", key: "to" },
            {
                title: "Action", key: "operation", fixed: "right", width: 100,
                render: (item) => (
                    <div>
                        <Button type="link" onClick={() => this.editWorkExperience(item)} style={{ color: "#1890ff", marginRight: 8, padding: 0 }}>
                            <Icon type="edit" />
                        </Button>
                        <Button type="link" onClick={() => this.setState({ totalData1: _.reject(this.state.totalData1, item) }, () => this.calculateGap())} style={{ color: "red", padding: 0 }}>
                            <Icon type="delete" />
                        </Button>
                    </div>
                ),
            },
        ];

        const tab1Completed = completeData && completeData.studentName && completeData.dateOfBirth && completeData.mobile && completeData.nationality && completeData.citizenship && completeData.operationManagerId;
        const tab2Completed = completeData && completeData.enqType;
        const tab3Completed = this.state.totalPreference && this.state.totalPreference.length > 0;
        const tab4Completed = (list && list.length > 0) || (completeData && completeData.profile && completeData.profile.newQualification && completeData.profile.newQualification.length > 0);

        // Level-based Stack Evaluation
        const showPostgradCard = highestEducationLevel === "Postgraduate";
        const showUndergradCard = highestEducationLevel === "Postgraduate" || highestEducationLevel === "Undergraduate";
        const showGrade12Card = highestEducationLevel === "Postgraduate" || highestEducationLevel === "Undergraduate" || highestEducationLevel === "Grade 12th or equivalent";
        const showGrade10Card = !!highestEducationLevel;

        // Extract student details for the top card
        let picString = completeData && completeData.profilePic ? (Array.isArray(completeData.profilePic) ? (completeData.profilePic[0] ? completeData.profilePic[0].url : null) : completeData.profilePic) : null;
        let studentImg = picString ? (picString.startsWith('http') ? picString : MEDIA_URL + picString) : (this.state.imageSrc || null);
        if (studentImg && studentImg.includes("default.png") && !this.state.imageSrc) {
            studentImg = null;
        }
        const studentName = (completeData && completeData.studentName) || "Student Name";
        const studentEmail = (completeData && completeData.emailId) || 'N/A';
        const studentPhone = completeData && completeData.mobile ? `${completeData.countryCode ? completeData.countryCode + ' ' : ''}${completeData.mobile}` : 'N/A';
        const studentId = (completeData && completeData.id) || (completeData && completeData._id ? completeData._id.substring(0, 8) : 'N/A');
        let studentDesk = completeData && completeData.atLevel ? completeData.atLevel : "Counselling Desk";
        if (studentDesk === "Front Desk") {
            studentDesk = "Counselling Desk";
        }

        return (
            <div style={{ background: '#f0f2f5', minHeight: '100vh', padding: '24px 24px' }}>

                {/* TOP STUDENT SUMMARY HEADER CARD */}
                {completeData && (
                    <Card bodyStyle={{ padding: '24px 32px', display: 'flex', alignItems: 'center', gap: 32 }} style={{ borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,0.05)', marginBottom: 24, border: 'none' }}>
                        {/* Left Card: Circular Avatar */}
                        <div style={{ position: 'relative', flexShrink: 0 }}>
                            <Avatar
                                src={studentImg || "https://bootdey.com/img/Content/avatar/avatar7.png"}
                                size={96}
                                style={{ boxShadow: '0 8px 16px rgba(24,144,255,0.2)', border: '4px solid #fff' }}
                            />
                            <div style={{ position: 'absolute', bottom: 4, right: 4, width: 16, height: 16, borderRadius: '50%', background: '#52c41a', border: '3px solid #fff' }}></div>
                        </div>

                        {/* Right Card: Details */}
                        <div style={{ flex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 24 }}>
                            <div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <h2 style={{ margin: 0, fontWeight: 700, fontSize: 24, color: '#1f2937' }}>{studentName}</h2>
                                    <Tag color="blue" style={{ borderRadius: 12, padding: '0 12px', fontWeight: 600 }}>VID: {studentId}</Tag>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', gap: 24, marginTop: 12, flexWrap: 'wrap' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', color: '#4b5563', fontSize: 14 }}>
                                        <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#f3f4f6', display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: 8 }}>
                                            <Icon type="mail" style={{ color: '#6b7280' }} />
                                        </div>
                                        {studentEmail}
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', color: '#4b5563', fontSize: 14 }}>
                                        <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#f3f4f6', display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: 8 }}>
                                            <Icon type="phone" style={{ color: '#6b7280' }} />
                                        </div>
                                        {studentPhone}
                                    </div>
                                </div>
                            </div>

                            {/* Desk Badge */}
                            <div style={{ background: 'linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%)', padding: '12px 24px', borderRadius: 12, border: '1px solid #91d5ff', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', boxShadow: '0 2px 8px rgba(24,144,255,0.1)' }}>
                                <span style={{ fontSize: 12, color: '#0050b3', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>Current Desk</span>
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                                    <Icon type="apartment" style={{ color: '#1890ff', fontSize: 18, marginRight: 8 }} />
                                    <span style={{ fontSize: 16, fontWeight: 700, color: '#002766' }}>{studentDesk}</span>
                                </div>
                            </div>
                        </div>
                    </Card>
                )}

                {/* MAIN FORM CONTAINER CARD */}
                <Card bodyStyle={{ padding: 24 }} style={{ borderRadius: 8 }}>
                    <Tabs
                        activeKey={this.state.activeTab || "1"}
                        tabPosition="top"
                        onChange={this.callback}
                        tabBarStyle={{ borderBottom: '1px solid #e5e7eb', marginBottom: 20 }}
                    >
                        <TabPane
                            tab={
                                <div style={{ textAlign: 'center', padding: '0 12px' }}>
                                    <div style={{ fontWeight: 600, fontSize: 14, color: '#1e3a8a' }}>Personal Information</div>
                                    {tab1Completed ? (
                                        <div style={{ fontSize: 12, color: '#52c41a', marginTop: 2 }}>Completed</div>
                                    ) : (
                                        <div style={{ fontSize: 12, color: '#ef4444', marginTop: 2 }}>Incomplete</div>
                                    )}
                                </div>
                            }
                            key="1"
                        >
                            {/* MAIN EDIT FORM (UNTOUCHED AND INTACT) */}
                            <Form onSubmit={this.handleSubmitTab1} layout="vertical">

                                {/* CONTAINER 1: PERSONAL DETAILS */}
                                <div style={{ background: "#fff", padding: "20px", borderRadius: "10px", border: "1px solid #f0f0f0", marginBottom: 20, boxShadow: "0 1px 3px rgba(0,0,0,0.02)", borderLeft: "4px solid #1890ff" }}>
                                    <SectionTitle icon="idcard" title="Personal Details" color="#1890ff" bgColor="#e6f7ff" />
                                    <Row gutter={16}>
                                        <Col span={8}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Full Name</span>}>
                                                {getFieldDecorator("studentName", { rules: [{ required: true, message: "Enter full name" }] })(
                                                    <Input size="large" placeholder="Enter Full Name" disabled={!(user && (user.isOperationManager || user.isAdministrator))} />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Date Of Birth</span>}>
                                                {getFieldDecorator("dateOfBirth", { rules: [{ required: true, message: "Select DOB" }] })(
                                                    <DatePicker size="large" style={{ width: '100%' }} format="DD/MM/YYYY" placeholder="Select DOB" />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Gender</span>}>
                                                {getFieldDecorator("gender", { rules: [{ required: true, message: "Select gender" }] })(
                                                    <Select showSearch optionFilterProp='children' size="large" placeholder="Select Gender">
                                                        {this.state.genderArr.map(g => <Select.Option key={g} value={g}>{g}</Select.Option>)}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Row gutter={16}>
                                        <Col span={8}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Marital Status</span>}>
                                                {getFieldDecorator("maritalStatus", { rules: [{ required: true, message: "Select marital status" }] })(
                                                    <Select showSearch optionFilterProp='children' size="large" placeholder="Select Status">
                                                        {this.state.maritalArr.map(m => <Select.Option key={m} value={m}>{m}</Select.Option>)}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>How did you come to know about us?</span>}>
                                                {getFieldDecorator("mode", { rules: [{ required: true, message: "Select source mode" }] })(
                                                    <Select size="large" showSearch optionFilterProp='children' placeholder="Select Source">
                                                        {this.state.modeArr.map(s => <Select.Option key={s} value={s}>{s}</Select.Option>)}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>How do you want us to contact?</span>}>
                                                {getFieldDecorator("howToContact")(
                                                    <Select showSearch optionFilterProp='children' size="large" placeholder="Contact Method">
                                                        <Select.Option value="Direct Mobile Call">Direct Mobile Call</Select.Option>
                                                        <Select.Option value="Direct Whatsapp Call">Direct Whatsapp Call</Select.Option>
                                                        <Select.Option value="Only Whatsapp Message">Only Whatsapp Message</Select.Option>
                                                        <Select.Option value="Only Email">Only Email</Select.Option>
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Row gutter={16}>
                                        <Col span={8}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Preferred time to contact you?</span>}>
                                                {getFieldDecorator("contactPreferredTime")(
                                                    <Select showSearch optionFilterProp='children' size="large" placeholder="Select Time Slot">
                                                        <Select.Option value="Anytime">Anytime</Select.Option>
                                                        <Select.Option value="10AM to 12PM">10AM to 12PM</Select.Option>
                                                        <Select.Option value="12PM to 2PM">12PM to 2PM</Select.Option>
                                                        <Select.Option value="2PM to 4PM">2PM to 4PM</Select.Option>
                                                        <Select.Option value="4PM to 6PM">4PM to 6PM</Select.Option>
                                                        <Select.Option value="After 6PM">After 6PM</Select.Option>
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Accompanied by Parent/Guardian</span>}>
                                                {getFieldDecorator("accompaniedByParentGuardian", { rules: [{ required: true, message: "Select status" }] })(
                                                    <Select showSearch optionFilterProp='children' size="large" placeholder="Select" onChange={v => this.setState({ showParentField: v === "Yes" })}>
                                                        <Select.Option value="Yes">Yes</Select.Option>
                                                        <Select.Option value="No">No</Select.Option>
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                        {this.state.showParentField && (
                                            <Col span={8}>
                                                <Form.Item label={<span style={{ fontWeight: 600 }}>Parent/Guardian Name</span>}>
                                                    {getFieldDecorator("parentGuardianName", { rules: [{ required: true, message: "Enter parent name" }] })(
                                                        <Input size="large" placeholder="Enter Parent Name" />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                        )}
                                    </Row>

                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Source</span>}>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <Input size="large" value={(() => {
                                                        let sourceDisplay = this.props.form.getFieldValue("location");
                                                        if (sourceDisplay === "Employee Referral") {
                                                            let emp = this.state.allEmployees.find(e => e.id === this.props.form.getFieldValue("employeeId"));
                                                            if (emp) sourceDisplay += ` (${emp.display})`;
                                                        } else if (sourceDisplay === "Lead Referral" || sourceDisplay === "External Referral") {
                                                            let ref = this.props.form.getFieldValue("referralName");
                                                            if (ref) sourceDisplay += ` (${ref})`;
                                                        } else if (sourceDisplay === "Loyality Program") {
                                                            let mem = this.state.allMembers.find(m => m.id === this.props.form.getFieldValue("membershipDetail"));
                                                            if (mem) sourceDisplay += ` (${mem.display})`;
                                                        } else if (sourceDisplay === "Sub Agent") {
                                                            let partner = (this.props.allChannelPartners || []).find(p => p._id === this.props.form.getFieldValue("associativePartnerId"));
                                                            if (partner) sourceDisplay += ` (${partner.branchName})`;
                                                        }
                                                        return sourceDisplay ? `Selected: ${sourceDisplay}` : "No Source Selected";
                                                    })()} readOnly style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }} />
                                                    <Button size="large" type="primary" onClick={() => this.setState({ showSourceModal: true })} style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}>
                                                        {user && (user.isOperationManager || user.isAdministrator || user.isStateHead) ? "Edit Source" : "View Source"}
                                                    </Button>
                                                </div>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>

                                {/* CONTAINER 2: CONTACT DETAILS */}
                                <div style={{ background: "#fff", padding: "20px", borderRadius: "10px", border: "1px solid #f0f0f0", marginBottom: 20, boxShadow: "0 1px 3px rgba(0,0,0,0.02)", borderLeft: "4px solid #52c41a" }}>
                                    <SectionTitle icon="phone" title="Contact Details" color="#52c41a" bgColor="#f6ffed" />
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Country</span>}>
                                                {getFieldDecorator("addressCountryId", { rules: [{ required: true, message: "Select country" }] })(
                                                    <Select size="large" showSearch optionFilterProp='children' placeholder="Select Country" onChange={v => {
                                                        if (dealingCountryPhoneCodes) {
                                                            let phoneCodeValue = (dealingCountryPhoneCodes[v] !== undefined ? dealingCountryPhoneCodes[v] : '');
                                                            this.props.form.setFieldsValue({ countryCode: phoneCodeValue });
                                                        }
                                                        this.props.form.setFieldsValue({ addressCountryId: v });
                                                    }}>
                                                        {this.state.dealingCountryFieldArr.map(c => <Select.Option key={c._id} value={c._id}>{c.display}</Select.Option>)}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>

                                        {/* Mobile Number with Country Code */}
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}> <span style={{ color: 'red' }}>*</span> Mobile Number</span>}>
                                                <Input.Group compact>
                                                    {getFieldDecorator("countryCode")(
                                                        <Select size="large" style={{ width: '32%' }} showSearch optionFilterProp='children' placeholder="Code">
                                                            {dealingPhoneCodes.map(code => <Select.Option key={code} value={code}>{code}</Select.Option>)}
                                                        </Select>
                                                    )}
                                                    {getFieldDecorator("mobile", { rules: [{ required: true, message: "Enter mobile number" }] })(
                                                        <Input style={{ width: '68%' }} size="large" type="number" placeholder="Enter Mobile Number" />
                                                    )}
                                                </Input.Group>
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Row gutter={16}>
                                        {/* Parents Number with Country Code */}
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}> <span style={{ color: 'red' }}>*</span> Parents Number</span>}>
                                                <Input.Group compact>
                                                    {getFieldDecorator("countryCode")(
                                                        <Select size="large" style={{ width: '32%' }} showSearch optionFilterProp='children' placeholder="Code">
                                                            {dealingPhoneCodes.map(code => <Select.Option key={code} value={code}>{code}</Select.Option>)}
                                                        </Select>
                                                    )}
                                                    {getFieldDecorator("parentMobile", { rules: [{ required: true, message: "Enter parents mobile" }] })(
                                                        <Input style={{ width: '68%' }} size="large" type="number" placeholder="Parents Mobile Number" />
                                                    )}
                                                </Input.Group>
                                            </Form.Item>
                                        </Col>

                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Does Applicant have Email?</span>}>
                                                {getFieldDecorator("ifApplicantHasEmail", { initialValue: "Yes" })(
                                                    <Select showSearch optionFilterProp='children' size="large" onChange={v => this.setState({ ifApplicantHasEmail: v === "Yes" })}>
                                                        <Select.Option value="Yes">Yes</Select.Option>
                                                        <Select.Option value="No">No</Select.Option>
                                                        <Select.Option value="Asked But Not Given">Asked But Not Given</Select.Option>
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Row gutter={16}>
                                        {this.state.ifApplicantHasEmail && (
                                            <Col span={12}>
                                                <Form.Item label={<span style={{ fontWeight: 600 }}>Email Address</span>}>
                                                    {getFieldDecorator("emailId", { rules: [{ required: true, message: "Enter email" }, { type: "email", message: "Invalid email" }] })(
                                                        <Input size="large" placeholder="Enter Email Address" prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />} />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                        )}
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Is WhatsApp Number different?</span>}>
                                                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "4px" }}>
                                                    {getFieldDecorator("ifWhatsAppNumberIsDifferentSwitch", { valuePropName: 'checked' })(
                                                        <Switch onChange={v => this.setState({ ifWhatsAppNumberIsDifferentSwitch: v })} />
                                                    )}
                                                    <span style={{ fontSize: 12, color: "#8c8c8c" }}>{this.state.ifWhatsAppNumberIsDifferentSwitch ? "Yes, enter below" : "No, same as mobile"}</span>
                                                </div>
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    {/* WhatsApp Number with Country Code */}
                                    {this.state.ifWhatsAppNumberIsDifferentSwitch && (
                                        <Row gutter={16}>
                                            <Col span={12}>
                                                <Form.Item label={<span style={{ fontWeight: 600 }}>WhatsApp Number</span>}>
                                                    <Input.Group compact>
                                                        {getFieldDecorator("countryCode")(
                                                            <Select size="large" style={{ width: '32%' }} showSearch optionFilterProp='children' placeholder="Code">
                                                                {dealingPhoneCodes.map(code => <Select.Option key={code} value={code}>{code}</Select.Option>)}
                                                            </Select>
                                                        )}
                                                        {getFieldDecorator("watsupp", { rules: [{ required: true, message: "Enter WhatsApp number" }] })(
                                                            <Input style={{ width: '68%' }} size="large" type="number" placeholder="Enter WhatsApp Number" prefix={<Icon type="whatsapp" style={{ color: '#52c41a' }} />} />
                                                        )}
                                                    </Input.Group>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    )}
                                </div>

                                {/* CONTAINER 3: MAILING & PERMANENT ADDRESS */}
                                <div style={{ background: "#fff", padding: "20px", borderRadius: "10px", border: "1px solid #f0f0f0", marginBottom: 20, boxShadow: "0 1px 3px rgba(0,0,0,0.02)", borderLeft: "4px solid #fa8c16" }}>
                                    <SectionTitle icon="environment" title="Mailing Address" color="#fa8c16" bgColor="#fff7e6" />
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Address 1</span>}>
                                                {getFieldDecorator("address", { rules: [{ required: true, message: "Enter mailing address" }] })(
                                                    <Input.TextArea rows={2} placeholder="Enter Mailing Address" />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Country</span>}>
                                                {getFieldDecorator("permanentAddressCountry", { rules: [{ required: true, message: "Select country" }] })(
                                                    <Select size="large" showSearch optionFilterProp='children' placeholder="Select Country" onChange={v => this.loadStates(v)}>
                                                        {this.state.dealingCountryFieldArr.map(c => <Select.Option key={c._id} value={c._id}>{c.display}</Select.Option>)}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>State</span>}>
                                                {getFieldDecorator("permanentAddressState", { rules: [{ required: true, message: "Select state" }] })(
                                                    <Select size="large" showSearch optionFilterProp='children' placeholder="Select State" onChange={v => this.loadCitiesByState(v)}>
                                                        {this.state.statesData.map(s => <Select.Option key={s._id} value={s._id}>{s.display}</Select.Option>)}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>City</span>}>
                                                {getFieldDecorator("permanentAddressCity", { rules: [{ required: true, message: "Select city" }] })(
                                                    <Select size="large" showSearch optionFilterProp='children' placeholder="Select City">
                                                        {this.state.citiesData.map(c => <Select.Option key={c._id} value={c._id}>{c.display}</Select.Option>)}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <div style={{ marginTop: 12, marginBottom: 12 }}>
                                        <Form.Item style={{ marginBottom: 0 }}>
                                            {getFieldDecorator("sameAsPeramanentAddress", { valuePropName: 'checked' })(
                                                <Switch onChange={v => this.setState({ sameAsPeramanentAddress: v })} />
                                            )}
                                            <span style={{ marginLeft: 10, fontWeight: 600 }}>Same as Mailing Address</span>
                                        </Form.Item>
                                    </div>

                                    {!this.state.sameAsPeramanentAddress && (
                                        <>
                                            <SectionTitle icon="environment" title="Permanent Address" color="#fa8c16" bgColor="#fff7e6" />
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <Form.Item label={<span style={{ fontWeight: 600 }}>Address 1</span>}>
                                                        {getFieldDecorator("currentAddress")(
                                                            <Input.TextArea rows={2} placeholder="Enter Permanent Address" />
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item label={<span style={{ fontWeight: 600 }}>Country</span>}>
                                                        {getFieldDecorator("currentAddressCountry")(
                                                            <Select size="large" showSearch optionFilterProp='children' placeholder="Select Country" onChange={v => this.loadStates(v)}>
                                                                {this.state.dealingCountryFieldArr.map(c => <Select.Option key={c._id} value={c._id}>{c.display}</Select.Option>)}
                                                            </Select>
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </>
                                    )}
                                </div>

                                {/* CONTAINER 4: PASSPORT DETAILS */}
                                <div style={{ background: "#fff", padding: "20px", borderRadius: "10px", border: "1px solid #f0f0f0", marginBottom: 20, boxShadow: "0 1px 3px rgba(0,0,0,0.02)", borderLeft: "4px solid #722ed1" }}>
                                    <SectionTitle icon="file-protect" title="Passport Information" color="#722ed1" bgColor="#f9f0ff" />
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Do you have a Passport?</span>}>
                                                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "4px" }}>
                                                    {getFieldDecorator("havePassport", { valuePropName: 'checked' })(
                                                        <Switch onChange={v => this.setState({ havePassport: v })} />
                                                    )}
                                                    <span style={{ fontSize: 12, color: "#8c8c8c" }}>{this.state.havePassport ? "Yes, I have passport" : "No passport yet"}</span>
                                                </div>
                                            </Form.Item>
                                        </Col>

                                        {this.state.havePassport && (
                                            <Col span={12}>
                                                <Form.Item label={<span style={{ fontWeight: 600 }}>Passport Number</span>}>
                                                    {getFieldDecorator("passport", { rules: [{ required: true, message: "Enter passport number" }] })(
                                                        <Input size="large" placeholder="Enter Passport Number" style={{ textTransform: "uppercase" }} />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                        )}
                                    </Row>
                                </div>

                                {/* CONTAINER 5: NATIONALITY */}
                                <div style={{ background: "#fff", padding: "20px", borderRadius: "10px", border: "1px solid #f0f0f0", marginBottom: 20, boxShadow: "0 1px 3px rgba(0,0,0,0.02)", borderLeft: "4px solid #13c2c2" }}>
                                    <SectionTitle icon="global" title="Nationality & Citizenship" color="#13c2c2" bgColor="#e6fffb" />
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Nationality</span>}>
                                                {getFieldDecorator("nationality", { rules: [{ required: true, message: "Select nationality" }] })(
                                                    <Select size="large" showSearch optionFilterProp='children' placeholder="Select Nationality">
                                                        {this.state.countryFieldArr.map(c => <Select.Option key={c._id} value={c._id}>{c.display}</Select.Option>)}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Citizenship</span>}>
                                                {getFieldDecorator("citizenship", { rules: [{ required: true, message: "Select citizenship" }] })(
                                                    <Select size="large" showSearch optionFilterProp='children' placeholder="Select Citizenship">
                                                        {this.state.countryFieldArr.map(c => <Select.Option key={c._id} value={c._id}>{c.display}</Select.Option>)}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Is the applicant a citizen of more than one country?</span>}>
                                                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "4px" }}>
                                                    {getFieldDecorator("applicantCitizenMoreCountrySwitch", { valuePropName: 'checked' })(
                                                        <Switch onChange={v => this.setState({ applicantCitizenMoreCountrySwitch: v })} />
                                                    )}
                                                    <span style={{ fontSize: 12, color: "#8c8c8c" }}>{this.state.applicantCitizenMoreCountrySwitch ? "Yes" : "No"}</span>
                                                </div>
                                            </Form.Item>
                                        </Col>
                                        {this.state.applicantCitizenMoreCountrySwitch && (
                                            <Col span={12}>
                                                <Form.Item label={<span style={{ fontWeight: 600 }}>Select Other Country</span>}>
                                                    {getFieldDecorator("applicantCitizenMoreCountry", { rules: [{ required: true, message: "Select country" }] })(
                                                        <Select size="large" showSearch optionFilterProp='children' placeholder="Select Country">
                                                            {this.state.countryFieldArr.map(c => <Select.Option key={c._id} value={c._id}>{c.display}</Select.Option>)}
                                                        </Select>
                                                    )}
                                                </Form.Item>
                                            </Col>
                                        )}
                                    </Row>

                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Is the applicant living and studying in any other country?</span>}>
                                                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "4px" }}>
                                                    {getFieldDecorator("applicantLivingStudyingAnyOtherCountrySwitch", { valuePropName: 'checked' })(
                                                        <Switch onChange={v => this.setState({ applicantLivingStudyingAnyOtherCountrySwitch: v })} />
                                                    )}
                                                    <span style={{ fontSize: 12, color: "#8c8c8c" }}>{this.state.applicantLivingStudyingAnyOtherCountrySwitch ? "Yes" : "No"}</span>
                                                </div>
                                            </Form.Item>
                                        </Col>
                                        {this.state.applicantLivingStudyingAnyOtherCountrySwitch && (
                                            <Col span={12}>
                                                <Form.Item label={<span style={{ fontWeight: 600 }}>Select Country</span>}>
                                                    {getFieldDecorator("applicantLivingStudyingAnyOtherCountry", { rules: [{ required: true, message: "Select country" }] })(
                                                        <Select size="large" showSearch optionFilterProp='children' placeholder="Select Country">
                                                            {this.state.countryFieldArr.map(c => <Select.Option key={c._id} value={c._id}>{c.display}</Select.Option>)}
                                                        </Select>
                                                    )}
                                                </Form.Item>
                                            </Col>
                                        )}
                                    </Row>
                                </div>

                                {/* CONTAINER 6: BACKGROUND INFO */}
                                <div style={{ background: "#fff", padding: "20px", borderRadius: "10px", border: "1px solid #f0f0f0", marginBottom: 20, boxShadow: "0 1px 3px rgba(0,0,0,0.02)", borderLeft: "4px solid #fa8c16" }}>
                                    <SectionTitle icon="info-circle" title="Background Information" color="#fa8c16" bgColor="#fff7e6" />
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Have Background Information?</span>}>
                                                {getFieldDecorator("haveBackgroundInformation", { initialValue: "No" })(
                                                    <Select showSearch optionFilterProp='children' size="large" onChange={v => this.setState({ haveBackgroundInformation: v === "Yes" })}>
                                                        <Select.Option value="Yes">Yes</Select.Option>
                                                        <Select.Option value="No">No</Select.Option>
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    {this.state.haveBackgroundInformation && (
                                        <>
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <Form.Item label={<span style={{ fontWeight: 600 }}>Applied for Immigration / PR?</span>}>
                                                        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "4px" }}>
                                                            {getFieldDecorator("applicantAppliedAnyTypeImmigrationCountryIdSwitch", { valuePropName: 'checked' })(
                                                                <Switch onChange={v => this.setState({ applicantAppliedAnyTypeImmigrationCountryIdSwitch: v })} />
                                                            )}
                                                            <span style={{ fontSize: 12, color: "#8c8c8c" }}>{this.state.applicantAppliedAnyTypeImmigrationCountryIdSwitch ? "Yes" : "No"}</span>
                                                        </div>
                                                    </Form.Item>
                                                </Col>
                                                {this.state.applicantAppliedAnyTypeImmigrationCountryIdSwitch && (
                                                    <Col span={12}>
                                                        <Form.Item label={<span style={{ fontWeight: 600 }}>Select Country</span>}>
                                                            {getFieldDecorator("applicantAppliedAnyTypeImmigrationCountryId", { rules: [{ required: true, message: "Select country" }] })(
                                                                <Select size="large" showSearch optionFilterProp='children' placeholder="Select Country">
                                                                    {this.state.countryFieldArr.map(c => <Select.Option key={c._id} value={c._id}>{c.display}</Select.Option>)}
                                                                </Select>
                                                            )}
                                                        </Form.Item>
                                                    </Col>
                                                )}
                                            </Row>

                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <Form.Item label={<span style={{ fontWeight: 600 }}>Suffer from serious medical condition?</span>}>
                                                        {getFieldDecorator("applicantSufferMedicalCondition", { initialValue: "No" })(
                                                            <Select showSearch optionFilterProp='children' size="large" onChange={v => this.setState({ applicantSufferMedicalCondition: v === "Yes" })}>
                                                                <Select.Option value="Yes">Yes</Select.Option>
                                                                <Select.Option value="No">No</Select.Option>
                                                            </Select>
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                                {this.state.applicantSufferMedicalCondition && (
                                                    <Col span={12}>
                                                        <Form.Item label={<span style={{ fontWeight: 600 }}>Explain Medical Condition</span>}>
                                                            {getFieldDecorator("applicantMedicalCondition", { rules: [{ required: true, message: "Explain medical condition" }] })(
                                                                <Input.TextArea rows={2} placeholder="Specify Medical Condition..." />
                                                            )}
                                                        </Form.Item>
                                                    </Col>
                                                )}
                                            </Row>

                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <Form.Item label={<span style={{ fontWeight: 600 }}>Has Visa refusal for any country?</span>}>
                                                        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "4px" }}>
                                                            {getFieldDecorator("applicantVisaRefusalCountryIdSwitch", { valuePropName: 'checked' })(
                                                                <Switch onChange={v => this.setState({ applicantVisaRefusalCountryIdSwitch: v })} />
                                                            )}
                                                            <span style={{ fontSize: 12, color: "#8c8c8c" }}>{this.state.applicantVisaRefusalCountryIdSwitch ? "Yes" : "No"}</span>
                                                        </div>
                                                    </Form.Item>
                                                </Col>
                                                {this.state.applicantVisaRefusalCountryIdSwitch && (
                                                    <Col span={12}>
                                                        <Form.Item label={<span style={{ fontWeight: 600 }}>Select Country</span>}>
                                                            {getFieldDecorator("applicantVisaRefusalCountryId", { rules: [{ required: true, message: "Select country" }] })(
                                                                <Select size="large" showSearch optionFilterProp='children' placeholder="Select Country">
                                                                    {this.state.countryFieldArr.map(c => <Select.Option key={c._id} value={c._id}>{c.display}</Select.Option>)}
                                                                </Select>
                                                            )}
                                                        </Form.Item>
                                                    </Col>
                                                )}
                                            </Row>

                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <Form.Item label={<span style={{ fontWeight: 600 }}>Has applicant ever been convicted of a criminal offence?</span>}>
                                                        {getFieldDecorator("applicantConvictedCriminalOffence", { initialValue: "No" })(
                                                            <Select showSearch optionFilterProp='children' size="large" onChange={v => this.setState({ applicantConvictedCriminalOffence: v === "Yes" })}>
                                                                <Select.Option value="Yes">Yes</Select.Option>
                                                                <Select.Option value="No">No</Select.Option>
                                                            </Select>
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                                {this.state.applicantConvictedCriminalOffence && (
                                                    <Col span={12}>
                                                        <Form.Item label={<span style={{ fontWeight: 600 }}>Explain Criminal Offence</span>}>
                                                            {getFieldDecorator("applicantCriminalOffence", { rules: [{ required: true, message: "Explain criminal offence" }] })(
                                                                <Input.TextArea rows={2} placeholder="Specify Criminal Offence..." />
                                                            )}
                                                        </Form.Item>
                                                    </Col>
                                                )}
                                            </Row>
                                        </>
                                    )}
                                </div>

                                {/* CONTAINER 7: IMPORTANT CONTACTS */}
                                <div style={{ background: "#fff", padding: "20px", borderRadius: "10px", border: "1px solid #f0f0f0", marginBottom: 20, boxShadow: "0 1px 3px rgba(0,0,0,0.02)", borderLeft: "4px solid #eb2f96" }}>
                                    <SectionTitle icon="contacts" title="Important Contacts" color="#eb2f96" bgColor="#fff0f6" />
                                    <Row gutter={16}>
                                        <Col span={8}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Name</span>}>
                                                {getFieldDecorator("emergencyName")(
                                                    <Input size="large" placeholder="Enter Contact Name" />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        {/* Emergency Contact Phone with Country Code */}
                                        <Col span={8}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Phone</span>}>
                                                <Input.Group compact>
                                                    {getFieldDecorator("emergencyCountryCode")(
                                                        <Select size="large" style={{ width: '38%' }} showSearch optionFilterProp='children' placeholder="Code">
                                                            {phoneCodes.map(code => <Select.Option key={code} value={code}>{code}</Select.Option>)}
                                                        </Select>
                                                    )}
                                                    {getFieldDecorator("landline")(
                                                        <Input style={{ width: '62%' }} size="large" type="number" placeholder="Enter Phone Number" />
                                                    )}
                                                </Input.Group>
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Email Address</span>}>
                                                {getFieldDecorator("emergencyEmail")(
                                                    <Input size="large" type="email" placeholder="Enter Email Address" />
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={16}>
                                        <Col span={8}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Relation with Applicant</span>}>
                                                {getFieldDecorator("emergencyRelationShip")(
                                                    <Input size="large" placeholder="e.g. Father, Uncle, Friend" />
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>

                                {/* CONTAINER 8: ASSIGNMENT INFO */}
                                <div style={{ background: "#fff", padding: "20px", borderRadius: "10px", border: "1px solid #f0f0f0", marginBottom: 20, boxShadow: "0 1px 3px rgba(0,0,0,0.02)", borderLeft: "4px solid #722ed1" }}>
                                    <SectionTitle icon="team" title="Assignment Info" color="#722ed1" bgColor="#f9f0ff" />
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Operation Manager</span>}>
                                                {getFieldDecorator("operationManagerId", { rules: [{ required: true, message: "Select operation manager" }] })(
                                                    <Select size="large" showSearch optionFilterProp='children' placeholder="Select Operation Manager" allowClear>
                                                        {(this.state.operationManagers || []).map(om => (
                                                            <Select.Option key={om._id} value={om._id}>{om.name}</Select.Option>
                                                        ))}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Telecaller</span>}>
                                                {getFieldDecorator("telecallerId")(
                                                    <Select size="large" showSearch optionFilterProp='children' placeholder="Select Telecaller" allowClear disabled={this.state.isTelecallerUser}>
                                                        {(this.state.telecallers || []).map(tc => (
                                                            <Select.Option key={tc._id} value={tc._id}>{tc.name}</Select.Option>
                                                        ))}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    {studentDesk !== "Operation Manager Desk" && (
                                        <Row gutter={16}>
                                            <Col span={12}>
                                                <Form.Item label={<span style={{ fontWeight: 600 }}>Counsellor</span>}>
                                                    {getFieldDecorator("counsellorId", { rules: [{ required: true, message: "Select counsellor" }] })(
                                                        <Select size="large" showSearch optionFilterProp='children' placeholder="Select Counsellor">
                                                            {(this.state.allUsers || []).map(u => (
                                                                <Select.Option key={u._id} value={u._id}>{u.name}</Select.Option>
                                                            ))}
                                                        </Select>
                                                    )}
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item label={<span style={{ fontWeight: 600 }}>Sub Counsellor</span>}>
                                                    {getFieldDecorator("subCounsellorId")(
                                                        <Select size="large" mode="multiple" showSearch optionFilterProp='children' placeholder="Select Sub Counsellors">
                                                            {(this.state.allUsers || []).map(u => (
                                                                <Select.Option key={u._id} value={u._id}>{u.name}</Select.Option>
                                                            ))}
                                                        </Select>
                                                    )}
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    )}
                                </div>

                                {/* SUBMIT BUTTON BAR */}
                                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 24 }}>
                                    <Button type="primary" htmlType="submit" size="large" loading={this.props.loading} style={{ borderRadius: 6, minWidth: 200, height: 44, fontWeight: 600 }}>
                                        Save Personal Info
                                    </Button>
                                </div>

                                <Modal
                                    title="Select Source"
                                    visible={this.state.showSourceModal}
                                    forceRender={true}
                                    onOk={() => this.setState({ showSourceModal: false })}
                                    onCancel={() => this.setState({ showSourceModal: false })}
                                    footer={[
                                        <Button key="ok" type="primary" onClick={() => this.setState({ showSourceModal: false })}>
                                            Done
                                        </Button>
                                    ]}
                                    destroyOnClose={false}
                                >
                                    <Form.Item label={<span style={{ fontWeight: 600 }}>Reference</span>}>
                                        {getFieldDecorator("location")(
                                            <Select showSearch optionFilterProp='children' style={{ width: '100%' }} size="large" placeholder="Select Source" disabled={disableSource} onChange={v => {
                                                this.props.form.setFieldsValue({ location: v });
                                                this.loadAssociativePartners(v);
                                                if (v === "Employee Referral") {
                                                    this.loadEmployees();
                                                } else if (v === "Loyality Program") {
                                                    this.loadMembers();
                                                }
                                            }}>
                                                {sourceOptions.map(opt => <Select.Option key={opt} value={opt}>{opt}</Select.Option>)}
                                            </Select>
                                        )}
                                    </Form.Item>

                                    <Form.Item label={<span style={{ fontWeight: 600 }}>Users</span>} style={{ display: this.props.form.getFieldValue("location") === "Sub Agent" ? 'block' : 'none' }}>
                                        {getFieldDecorator("associativePartnerId", { rules: [{ required: this.props.form.getFieldValue("location") === "Sub Agent", message: "Select user" }] })(
                                            <Select style={{ width: '100%' }} size="large" showSearch optionFilterProp="children" placeholder="Select User" disabled={disableSubAgent}>
                                                {(this.props.allChannelPartners || []).map(cp => (
                                                    <Select.Option key={cp._id} value={cp._id}>{`${cp.branchName} ${cp.branchHeadPhone ? "(" + cp.branchHeadPhone + ")" : ""}`}</Select.Option>
                                                ))}
                                            </Select>
                                        )}
                                    </Form.Item>

                                    <Form.Item label={<span style={{ fontWeight: 600 }}>Employee Name</span>} style={{ display: this.props.form.getFieldValue("location") === "Employee Referral" ? 'block' : 'none' }}>
                                        {getFieldDecorator("employeeId", { rules: [{ required: this.props.form.getFieldValue("location") === "Employee Referral", message: "Select employee" }] })(
                                            <Select style={{ width: '100%' }} size="large" showSearch optionFilterProp="children" placeholder="Select Employee" disabled={disableEmployee}>
                                                {this.state.allEmployees.map(emp => (
                                                    <Select.Option key={emp.id} value={emp.id}>{emp.display}</Select.Option>
                                                ))}
                                            </Select>
                                        )}
                                    </Form.Item>

                                    <Form.Item label={<span style={{ fontWeight: 600 }}>Referral Name</span>} style={{ display: (this.props.form.getFieldValue("location") === "Lead Referral" || this.props.form.getFieldValue("location") === "External Referral") ? 'block' : 'none' }}>
                                        {getFieldDecorator("referralName", { rules: [{ required: (this.props.form.getFieldValue("location") === "Lead Referral" || this.props.form.getFieldValue("location") === "External Referral"), message: "Enter referral name" }] })(
                                            <Input style={{ width: '100%' }} size="large" placeholder="Enter referral name" disabled={disableReferral} />
                                        )}
                                    </Form.Item>

                                    <Form.Item label={<span style={{ fontWeight: 600 }}>Member Name</span>} style={{ display: this.props.form.getFieldValue("location") === "Loyality Program" ? 'block' : 'none' }}>
                                        {getFieldDecorator("membershipDetail", { rules: [{ required: this.props.form.getFieldValue("location") === "Loyality Program", message: "Select member" }] })(
                                            <Select style={{ width: '100%' }} size="large" showSearch optionFilterProp="children" placeholder="Select Member" disabled={disableMember}>
                                                {this.state.allMembers.map(mem => (
                                                    <Select.Option key={mem.id} value={mem.id}>{mem.display}</Select.Option>
                                                ))}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Modal>
                            </Form>
                        </TabPane>

                        {/* TAB 3: PREFERENCES */}
                        <TabPane
                            tab={
                                <div style={{ textAlign: 'center', padding: '0 12px' }}>
                                    <div style={{ fontWeight: 600, fontSize: 14, color: '#374151' }}>Preferences</div>
                                    {tab3Completed ? (
                                        <div style={{ fontSize: 12, color: '#52c41a', marginTop: 2 }}>Completed</div>
                                    ) : (
                                        <div style={{ fontSize: 12, color: '#ef4444', marginTop: 2 }}>Incomplete</div>
                                    )}
                                </div>
                            }
                            key="3"
                        >
                            <Form onSubmit={this.handleSubmitTab3} layout="vertical">
                                <div style={{ background: "#fff", padding: "20px", borderRadius: "10px", border: "1px solid #f0f0f0", marginBottom: 20, boxShadow: "0 1px 3px rgba(0,0,0,0.02)", borderLeft: "4px solid #1890ff" }}>
                                    <SectionTitle icon="global" title="Study Preferences" color="#1890ff" bgColor="#e6f7ff" />
                                    <Row gutter={16} type="flex" align="bottom">
                                        <Col span={8}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Select Country</span>} style={{ marginBottom: 0 }}>
                                                <Select
                                                    size="large"
                                                    placeholder="Select Country"
                                                    showSearch={true}
                                                    optionFilterProp="children"
                                                    value={this.state.country ? this.state.country._id : undefined}
                                                    onChange={(ei) => {
                                                        let singleCountry = _.find(this.state.countryFieldArr, item => item._id === ei);
                                                        if (singleCountry) this.loadStates(singleCountry._id);
                                                        this.setState({ country: singleCountry, prefState: null });
                                                    }}
                                                >
                                                    {this.state.countryFieldArr.map((val, index) => (
                                                        <Select.Option key={val._id} value={val._id}>{val.display}</Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Select State (Optional)</span>} style={{ marginBottom: 0 }}>
                                                <Select
                                                    size="large"
                                                    placeholder="Select State"
                                                    showSearch={true}
                                                    optionFilterProp="children"
                                                    value={this.state.prefState ? this.state.prefState._id : undefined}
                                                    onChange={(ei) => {
                                                        let singleState = _.find(this.state.statesData, item => item._id === ei);
                                                        this.setState({ prefState: singleState });
                                                    }}
                                                >
                                                    {this.state.statesData.map((val, index) => (
                                                        <Select.Option key={val._id} value={val._id}>{val.display}</Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Button type="primary" size="large" icon="plus" onClick={() => {
                                                if (!this.state.country) {
                                                    return notification.error({ message: "Choose Country" });
                                                }
                                                let tt = [...this.state.totalPreference];
                                                tt.push({ country: this.state.country, state: this.state.prefState });
                                                this.setState({ totalPreference: tt, edited: true, prefState: null, country: null });
                                            }} style={{ marginBottom: 2, width: '100%' }}>
                                                Add Preference
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                                {this.state.totalPreference && this.state.totalPreference.length > 0 && (
                                    <Table
                                        bordered={true}
                                        columns={preferenceColumns}
                                        dataSource={this.state.totalPreference}
                                        pagination={false}
                                        rowKey={(x, i) => i}
                                        style={{ marginBottom: 20 }}
                                    />
                                )}
                                <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '20px 0', borderTop: '1px solid #f0f0f0' }}>
                                    <Button type="primary" htmlType="submit" size="large" icon="save" style={{ minWidth: 150, height: 44, fontSize: 16, borderRadius: 6 }}>
                                        Save Preferences
                                    </Button>
                                </div>
                            </Form>
                        </TabPane>

                        {/* TAB 4: ACADEMIC QUALIFICATIONS WITH DYNAMIC LEVEL-BASED STACKED CARDS */}
                        <TabPane
                            tab={
                                <div style={{ textAlign: 'center', padding: '0 12px' }}>
                                    <div style={{ fontWeight: 600, fontSize: 14, color: '#374151' }}>Academic Qualifications</div>
                                    {tab4Completed ? (
                                        <div style={{ fontSize: 12, color: '#52c41a', marginTop: 2 }}>Completed</div>
                                    ) : (
                                        <div style={{ fontSize: 12, color: '#ef4444', marginTop: 2 }}>Incomplete</div>
                                    )}
                                </div>
                            }
                            key="4"
                        >
                            <Form onSubmit={this.handleSubmitTab4} layout="vertical">

                                {/* TOP SELECTOR ROW */}
                                <div style={{ background: "#fff", padding: "20px", borderRadius: "10px", border: "1px solid #f0f0f0", marginBottom: 20, boxShadow: "0 1px 3px rgba(0,0,0,0.02)" }}>
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Country of Education</span>}>
                                                {getFieldDecorator("countryOfEducation", { rules: [{ required: true, message: "Select country" }] })(
                                                    <Select size="large" showSearch optionFilterProp='children' placeholder="Select Country" onChange={this.handleCountryOfEducationChange}>
                                                        {this.state.dealingCountryFieldArr.map(c => <Select.Option key={c._id} value={c.display}>{c.display}</Select.Option>)}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label={<span style={{ fontWeight: 600 }}>Highest Level of Education</span>}>
                                                {getFieldDecorator("highestEducationLevel", { rules: [{ required: true, message: "Select highest level" }] })(
                                                    <Select showSearch optionFilterProp='children' size="large" placeholder="Select Highest Level" onChange={v => this.setState({ highestEducationLevel: v })}>
                                                        <Select.Option value="Postgraduate">Postgraduate</Select.Option>
                                                        <Select.Option value="Undergraduate">Undergraduate</Select.Option>
                                                        <Select.Option value="Grade 12th or equivalent">Grade 12th or equivalent</Select.Option>
                                                        <Select.Option value="Grade 10th or equivalent">Grade 10th or equivalent</Select.Option>
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>

                                {/* DYNAMICALLY STACKED QUALIFICATION CARDS */}

                                {/* 1. POSTGRADUATE CARD */}
                                {showPostgradCard && (
                                    <QualificationCard
                                        title="Postgraduate"
                                        icon="read"
                                        color="#1890ff"
                                        bgColor="#e6f7ff"
                                        idPrefix="pg"
                                        defaultCountry={countryOfEducation}
                                        form={this.props.form}
                                        countries={this.state.dealingCountryFieldArr}
                                        states={this.state.statesData}
                                    />
                                )}

                                {/* 2. UNDERGRADUATE CARD */}
                                {showUndergradCard && (
                                    <QualificationCard
                                        title="Undergraduate"
                                        icon="book"
                                        color="#722ed1"
                                        bgColor="#f9f0ff"
                                        idPrefix="ug"
                                        defaultCountry={countryOfEducation}
                                        form={this.props.form}
                                        countries={this.state.dealingCountryFieldArr}
                                        states={this.state.statesData}
                                    />
                                )}

                                {/* 3. GRADE 12TH OR EQUIVALENT CARD */}
                                {showGrade12Card && (
                                    <QualificationCard
                                        title="Grade 12th or equivalent"
                                        icon="solution"
                                        color="#fa8c16"
                                        bgColor="#fff7e6"
                                        idPrefix="g12"
                                        defaultCountry={countryOfEducation}
                                        form={this.props.form}
                                        countries={this.state.dealingCountryFieldArr}
                                        states={this.state.statesData}
                                    />
                                )}

                                {/* 4. GRADE 10TH OR EQUIVALENT CARD */}
                                {showGrade10Card && (
                                    <QualificationCard
                                        title="Grade 10th or equivalent"
                                        icon="snippets"
                                        color="#52c41a"
                                        bgColor="#f6ffed"
                                        idPrefix="g10"
                                        defaultCountry={countryOfEducation}
                                        form={this.props.form}
                                        countries={this.state.dealingCountryFieldArr}
                                        states={this.state.statesData}
                                    />
                                )}

                                {/* DYNAMIC ADDITIONAL QUALIFICATIONS CARDS WITH DROPDOWN LEVEL SELECTION */}
                                {additionalQualifications.map((addQual, index) => (
                                    <QualificationCard
                                        key={addQual.id}
                                        title={`Additional Qualification #${index + 1}`}
                                        icon="plus-circle"
                                        color="#eb2f96"
                                        bgColor="#fff0f6"
                                        idPrefix={`add_${addQual.id}`}
                                        defaultCountry={countryOfEducation}
                                        form={this.props.form}
                                        countries={this.state.dealingCountryFieldArr}
                                        states={this.state.statesData}
                                        isAdditional={true}
                                        onRemove={() => this.removeAdditionalQualificationCard(index)}
                                    />
                                ))}

                                {/* ADD ADDITIONAL QUALIFICATION BUTTON */}
                                {highestEducationLevel && (
                                    <div style={{ marginBottom: 24 }}>
                                        <Button
                                            type="dashed"
                                            block
                                            size="large"
                                            icon="plus"
                                            onClick={this.addAdditionalQualificationCard}
                                            style={{ height: 48, borderColor: "#1890ff", color: "#1890ff", fontWeight: 600, borderRadius: 8 }}
                                        >
                                            Add Additional Qualification
                                        </Button>
                                    </div>
                                )}

                                {highestEducationLevel && (
                                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
                                        <Button type="primary" htmlType="submit" size="large" loading={this.props.loading} style={{ borderRadius: 6, minWidth: 180, fontWeight: 600 }}>
                                            Save Qualifications
                                        </Button>
                                    </div>
                                )}
                            </Form>
                        </TabPane>

                        {/* TAB 5: WORK EXPERIENCE (WORK QUALIFICATIONS) */}
                        <TabPane
                            tab={
                                <div style={{ textAlign: 'center', padding: '0 12px' }}>
                                    <div style={{ fontWeight: 600, fontSize: 14, color: '#374151' }}>Work Experience</div>
                                    <div style={{ fontSize: 12, color: '#3b82f6', marginTop: 2 }}>Optional</div>
                                </div>
                            }
                            key="5"
                        >
                            {!showWorkExpForm ? (
                                <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                                    {/* Default View Illustration & Add Button */}
                                    <div style={{ marginBottom: 24 }}>
                                        <svg width="220" height="150" viewBox="0 0 200 130" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M160 90C180 80 190 60 170 40C150 20 110 20 90 40C70 20 30 30 20 60C10 90 40 110 80 110C120 110 140 100 160 90Z" fill="#E0F2FE" opacity="0.6" />
                                            <rect x="50" y="55" width="100" height="50" rx="6" fill="#1E40AF" />
                                            <rect x="60" y="65" width="35" height="25" rx="3" fill="#60A5FA" />
                                            <rect x="105" y="65" width="35" height="25" rx="3" fill="#93C5FD" />
                                            <circle cx="100" cy="40" r="12" fill="#3B82F6" />
                                            <path d="M92 52C92 46 108 46 108 52V55H92V52Z" fill="#1D4ED8" />
                                        </svg>
                                    </div>

                                    {/* Saved Job Records Table if present */}
                                    {this.state.totalData1 && this.state.totalData1.length > 0 && (
                                        <div style={{ marginBottom: 30, textAlign: 'left' }}>
                                            <Table bordered rowKey={(x, i) => i} columns={jobColumns} dataSource={this.state.totalData1} pagination={false} />
                                        </div>
                                    )}

                                    <Button
                                        type="primary"
                                        size="large"
                                        onClick={() => this.setState({ showWorkExpForm: true })}
                                        style={{ height: 48, borderRadius: 24, padding: '0 28px', fontSize: 15, fontWeight: 600, background: '#0284c7', borderColor: '#0284c7' }}
                                    >
                                        <Icon type="plus" /> Add Work Experience
                                    </Button>
                                </div>
                            ) : (
                                /* Work Qualifications Form Card */
                                <Form onSubmit={this.handleSubmitWorkExperience} layout="vertical">
                                    <div style={{ background: "#fff", padding: "20px", borderRadius: "10px", border: "1px solid #f0f0f0", marginBottom: 20, boxShadow: "0 1px 3px rgba(0,0,0,0.02)", borderLeft: "4px solid #1890ff" }}>
                                        <SectionTitle icon="shopping-bag" title="Work qualifications" color="#1890ff" bgColor="#e6f7ff" />

                                        <Row gutter={16}>
                                            <Col span={12}>
                                                <Form.Item label={<span style={{ fontWeight: 600 }}>Name of the Organisation & Address</span>}>
                                                    {getFieldDecorator("orgNameAddress", { rules: [{ required: true, message: "Enter organisation name & address" }] })(
                                                        <Input size="large" placeholder="Enter Name of the Organisation & Address" />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item label={<span style={{ fontWeight: 600 }}>Position</span>}>
                                                    {getFieldDecorator("position", { rules: [{ required: true, message: "Enter position" }] })(
                                                        <Input size="large" placeholder="Enter Position" />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Row gutter={16}>
                                            <Col span={12}>
                                                <Form.Item label={<span style={{ fontWeight: 600 }}>Job Profile</span>}>
                                                    {getFieldDecorator("jobProfile")(
                                                        <Input size="large" placeholder="Enter Job Profile" />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item label={<span style={{ fontWeight: 600 }}>Mode of Salary</span>}>
                                                    {getFieldDecorator("modeOfSalary")(
                                                        <Select showSearch optionFilterProp='children' size="large" placeholder="Select Mode of Salary">
                                                            <Select.Option value="Bank Transfer">Bank Transfer</Select.Option>
                                                            <Select.Option value="Cash">Cash</Select.Option>
                                                            <Select.Option value="Cheque">Cheque</Select.Option>
                                                        </Select>
                                                    )}
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Row gutter={16}>
                                            <Col span={12}>
                                                <Form.Item label={<span style={{ fontWeight: 600 }}>Working From</span>}>
                                                    {getFieldDecorator("workingFrom", { rules: [{ required: true, message: "Select start date" }] })(
                                                        <DatePicker size="large" style={{ width: '100%' }} format="DD/MM/YYYY" placeholder="Select Start Date" />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item label={<span style={{ fontWeight: 600 }}>Working upto</span>}>
                                                    {getFieldDecorator("workingUpto")(
                                                        <DatePicker size="large" style={{ width: '100%' }} format="DD/MM/YYYY" placeholder="Select End Date" disabled={isCurrentlyWorkingHere} />
                                                    )}
                                                </Form.Item>
                                                <div style={{ marginTop: 4 }}>
                                                    {getFieldDecorator("currentlyWorkingHere", { valuePropName: 'checked' })(
                                                        <Checkbox onChange={e => this.setState({ isCurrentlyWorkingHere: e.target.checked })}>
                                                            <span style={{ fontSize: 13, color: "#595959" }}>I am currently working here</span>
                                                        </Checkbox>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>

                                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 20 }}>
                                            <Button
                                                size="large"
                                                onClick={() => this.setState({ showWorkExpForm: false })}
                                                style={{ minWidth: 100, borderRadius: 6, fontWeight: 600, borderColor: '#1890ff', color: '#1890ff' }}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                type="primary"
                                                htmlType="submit"
                                                size="large"
                                                loading={this.props.loading}
                                                style={{ minWidth: 100, borderRadius: 6, fontWeight: 600, background: '#0284c7', borderColor: '#0284c7' }}
                                            >
                                                Save
                                            </Button>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </TabPane>

                        <TabPane
                            tab={
                                <div style={{ textAlign: 'center', padding: '0 12px' }}>
                                    <div style={{ fontWeight: 600, fontSize: 14, color: '#374151' }}>Language Proficiency</div>
                                    {tab2Completed ? (
                                        <div style={{ fontSize: 12, color: '#52c41a', marginTop: 2 }}>Completed</div>
                                    ) : (
                                        <div style={{ fontSize: 12, color: '#ef4444', marginTop: 2 }}>Incomplete</div>
                                    )}
                                </div>
                            }
                            key="2"
                        >
                            <Form2 allUsers={this.state.allUsers} form2Fields={this.setFormTwoData()} handleSubmitTab2={this.callbackForHandleSubmitTab2} loading={this.props.loading} />
                        </TabPane>
                    </Tabs>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    allChannelPartners: global.allChannelPartners,
    search: router.location.search,
});

const mapDispatchToProps = (dispatch) => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(EditInquiryV2);
